{
  "version": 1,
  "assetPolicy": "Original bitmap resources only, no AI repaint; gameplay parameters are explicitly later-source/prototype candidates",
  "maps": [
    {
      "id": "1030",
      "name": "幽冥村",
      "width": 1100,
      "height": 1334,
      "background": "/game/maps/1030/back.jpg",
      "foreground": "/game/maps/1030/fore.png",
      "mask": "/game/maps/1030/fore.map",
      "gravity": 10,
      "drag": 2,
      "spawnX": [
        143,
        297,
        440,
        660,
        803,
        957
      ],
      "spawnEvidence": "Prototype positions distributed on real mask; no claim of 2009 spawn DB",
      "physicsEvidence": "Matching later map Weight=10/DragIndex=2; 2009 constants unverified"
    },
    {
      "id": "1031",
      "name": "埃及招财猫",
      "width": 2428,
      "height": 1253,
      "background": "/game/maps/1031/back.jpg",
      "foreground": "/game/maps/1031/fore.png",
      "mask": "/game/maps/1031/fore.map",
      "gravity": 10,
      "drag": 2,
      "spawnX": [
        316,
        656,
        971,
        1457,
        1772,
        2112
      ],
      "spawnEvidence": "Prototype positions distributed on real mask; no claim of 2009 spawn DB",
      "physicsEvidence": "Matching later map Weight=10/DragIndex=2; 2009 constants unverified"
    },
    {
      "id": "1034",
      "name": "玛雅废墟",
      "width": 1400,
      "height": 1800,
      "background": "/game/maps/1034/back.jpg",
      "foreground": "/game/maps/1034/fore.png",
      "mask": "/game/maps/1034/fore.map",
      "gravity": 10,
      "drag": 2,
      "spawnX": [
        182,
        378,
        560,
        840,
        1022,
        1218
      ],
      "spawnEvidence": "Prototype positions distributed on real mask; no claim of 2009 spawn DB",
      "physicsEvidence": "Matching later map Weight=10/DragIndex=2; 2009 constants unverified"
    },
    {
      "id": "1001",
      "name": "彩虹桥",
      "width": 2000,
      "height": 1425,
      "background": "/game/maps/1001/back.jpg",
      "foreground": "/game/maps/1001/fore.png",
      "mask": "/game/maps/1001/fore.map",
      "gravity": 10,
      "drag": 2,
      "spawnX": [
        250,
        450,
        650,
        1350,
        1550,
        1750
      ],
      "spawnEvidence": "Preferred two-dimensional team points in shared/map-spawns.json start at y900 and settle onto safe sections of the genuine rainbow bridge mask. Explicit mask-derived fallback; original2009 PosX/PosX1 database unavailable. Legacy spawnX only retains horizontal compatibility.",
      "physicsEvidence": "Matching later map Weight=10/DragIndex=2; 2009 constants unverified",
      "sourceMusicId": "1001",
      "sourceConfiguration": "research/source-inspection/maps_characters/loadmapsitems.xml.decoded:249",
      "identityEvidence": {
        "status": "Dated2009 Rainbow Bridge map identity confirmed; precise later bitmap/mask bytes are not independently authenticated for2009",
        "name": "彩虹桥",
        "mapIdEvidence": "Original pinned Gunny3.0 map1001 files and later loadmapsitems ID1001 Name Ponte do Arco-Íris; exclude small1021 and newcomer1172 variants.",
        "datedArtUrl": "https://webgame.yzz.cn/jinriyaowen/200903/413_6.shtml",
        "officialNameUrl": "https://web.4399.com/ddt/wanjiaxinwen/201011/10-34820.html",
        "audit": "research/source-inspection/rainbow-map/audit.json"
      }
    }
  ],
  "weapons": [
    {
      "id": "bombpack",
      "pic": "bombpack",
      "name": "烈火",
      "templateId": "7006",
      "baseDamage": 205,
      "attack": 250,
      "defence": 60,
      "agility": 40,
      "luck": 30,
      "minAngle": 20,
      "maxAngle": 50,
      "icon": "/game/weapons/bombpack/icon.png",
      "held": "/game/weapons/bombpack/held.png",
      "heldSheet": "/game/weapons/bombpack/held-sheet.png",
      "heldAnchor": {
        "x": 62,
        "y": 83
      },
      "evidence": "Weapon family dated to 2009; original visuals and stats from later overseas archive; 2009 exact numerical/animation match pending",
      "laterArchiveAngles": [
        20,
        50
      ],
      "angleEvidence": {
        "status": "Dated 2009 official contemporary table takes precedence over later configuration",
        "sourceUrl": "https://web.4399.com/ddt/youxigonglue/200911/23-13312.html",
        "sourceFile": "research/source-inspection/weapon-audit/2009-nov-weapons.html"
      },
      "normal": {
        "power": 1.0,
        "radius": 55.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "bombpack-normal",
        "runtimeCraterId": "161",
        "projectile": [
          "/game/weapons/bombpack/normal/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-01.png",
          "/game/weapons/bombpack/normal/explosion/frame-02.png",
          "/game/weapons/bombpack/normal/explosion/frame-03.png",
          "/game/weapons/bombpack/normal/explosion/frame-04.png",
          "/game/weapons/bombpack/normal/explosion/frame-05.png",
          "/game/weapons/bombpack/normal/explosion/frame-06.png",
          "/game/weapons/bombpack/normal/explosion/frame-07.png",
          "/game/weapons/bombpack/normal/explosion/frame-08.png",
          "/game/weapons/bombpack/normal/explosion/frame-09.png",
          "/game/weapons/bombpack/normal/explosion/frame-10.png",
          "/game/weapons/bombpack/normal/explosion/frame-11.png",
          "/game/weapons/bombpack/normal/explosion/frame-12.png",
          "/game/weapons/bombpack/normal/explosion/frame-13.png",
          "/game/weapons/bombpack/normal/explosion/frame-14.png",
          "/game/weapons/bombpack/normal/explosion/frame-15.png",
          "/game/weapons/bombpack/normal/explosion/frame-16.png",
          "/game/weapons/bombpack/normal/explosion/frame-17.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png",
          "/game/weapons/bombpack/normal/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/bombpack/normal/crater.map",
        "crater": "/game/weapons/bombpack/normal/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/bombpack/normal/crater-mask.png",
        "craterTimeline": {
          "width": 130,
          "height": 90,
          "anchor": {
            "x": 65,
            "y": 45
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bombpack/normal/border/frame-00.png",
              "bitmap_ids": [
                73
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 75,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 48,
          "height": 40,
          "anchor": {
            "x": 24,
            "y": 20
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bombpack/normal/projectile/frame-00.png",
              "bitmap_ids": [
                80
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 82,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 368,
          "height": 435,
          "anchor": {
            "x": 261,
            "y": 139
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/bombpack/normal/explosion/frame-01.png",
              "bitmap_ids": [
                38
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/bombpack/normal/explosion/frame-02.png",
              "bitmap_ids": [
                40
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/bombpack/normal/explosion/frame-03.png",
              "bitmap_ids": [
                42
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/bombpack/normal/explosion/frame-04.png",
              "bitmap_ids": [
                44
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/bombpack/normal/explosion/frame-05.png",
              "bitmap_ids": [
                46
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/bombpack/normal/explosion/frame-06.png",
              "bitmap_ids": [
                48
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/bombpack/normal/explosion/frame-07.png",
              "bitmap_ids": [
                50
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/bombpack/normal/explosion/frame-08.png",
              "bitmap_ids": [
                52
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/bombpack/normal/explosion/frame-09.png",
              "bitmap_ids": [
                54
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/bombpack/normal/explosion/frame-10.png",
              "bitmap_ids": [
                56
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/bombpack/normal/explosion/frame-11.png",
              "bitmap_ids": [
                58
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/bombpack/normal/explosion/frame-12.png",
              "bitmap_ids": [
                60
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/bombpack/normal/explosion/frame-13.png",
              "bitmap_ids": [
                62
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/bombpack/normal/explosion/frame-14.png",
              "bitmap_ids": [
                64
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/bombpack/normal/explosion/frame-15.png",
              "bitmap_ids": [
                66
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/bombpack/normal/explosion/frame-16.png",
              "bitmap_ids": [
                68
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/bombpack/normal/explosion/frame-17.png",
              "bitmap_ids": [
                70
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/bombpack/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 72,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 16,
        "runtimeBallId": "161",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      },
      "special": {
        "power": 0.6,
        "radius": 45.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 3,
        "spin": 0,
        "craterId": "bombpack-special",
        "runtimeCraterId": "171",
        "projectile": [
          "/game/weapons/bombpack/special/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-01.png",
          "/game/weapons/bombpack/special/explosion/frame-02.png",
          "/game/weapons/bombpack/special/explosion/frame-03.png",
          "/game/weapons/bombpack/special/explosion/frame-04.png",
          "/game/weapons/bombpack/special/explosion/frame-05.png",
          "/game/weapons/bombpack/special/explosion/frame-06.png",
          "/game/weapons/bombpack/special/explosion/frame-07.png",
          "/game/weapons/bombpack/special/explosion/frame-08.png",
          "/game/weapons/bombpack/special/explosion/frame-09.png",
          "/game/weapons/bombpack/special/explosion/frame-10.png",
          "/game/weapons/bombpack/special/explosion/frame-11.png",
          "/game/weapons/bombpack/special/explosion/frame-12.png",
          "/game/weapons/bombpack/special/explosion/frame-13.png",
          "/game/weapons/bombpack/special/explosion/frame-14.png",
          "/game/weapons/bombpack/special/explosion/frame-15.png",
          "/game/weapons/bombpack/special/explosion/frame-16.png",
          "/game/weapons/bombpack/special/explosion/frame-17.png",
          "/game/weapons/bombpack/special/explosion/frame-18.png",
          "/game/weapons/bombpack/special/explosion/frame-19.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png",
          "/game/weapons/bombpack/special/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/bombpack/special/crater.map",
        "crater": "/game/weapons/bombpack/special/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/bombpack/special/crater-mask.png",
        "craterTimeline": {
          "width": 92,
          "height": 92,
          "anchor": {
            "x": 46,
            "y": 46
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bombpack/special/border/frame-00.png",
              "bitmap_ids": [
                78
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 80,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 31,
          "height": 39,
          "anchor": {
            "x": 15,
            "y": 24
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bombpack/special/projectile/frame-00.png",
              "bitmap_ids": [
                85
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 87,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 359,
          "height": 359,
          "anchor": {
            "x": 185,
            "y": 153
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/bombpack/special/explosion/frame-01.png",
              "bitmap_ids": [
                39
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/bombpack/special/explosion/frame-02.png",
              "bitmap_ids": [
                41
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/bombpack/special/explosion/frame-03.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/bombpack/special/explosion/frame-04.png",
              "bitmap_ids": [
                45
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/bombpack/special/explosion/frame-05.png",
              "bitmap_ids": [
                47
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/bombpack/special/explosion/frame-06.png",
              "bitmap_ids": [
                49
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/bombpack/special/explosion/frame-07.png",
              "bitmap_ids": [
                51
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/bombpack/special/explosion/frame-08.png",
              "bitmap_ids": [
                53
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/bombpack/special/explosion/frame-09.png",
              "bitmap_ids": [
                55
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/bombpack/special/explosion/frame-10.png",
              "bitmap_ids": [
                57
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/bombpack/special/explosion/frame-11.png",
              "bitmap_ids": [
                59
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/bombpack/special/explosion/frame-12.png",
              "bitmap_ids": [
                61
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/bombpack/special/explosion/frame-13.png",
              "bitmap_ids": [
                63
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/bombpack/special/explosion/frame-14.png",
              "bitmap_ids": [
                65
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/bombpack/special/explosion/frame-15.png",
              "bitmap_ids": [
                67
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/bombpack/special/explosion/frame-16.png",
              "bitmap_ids": [
                69
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/bombpack/special/explosion/frame-17.png",
              "bitmap_ids": [
                71
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/bombpack/special/explosion/frame-18.png",
              "bitmap_ids": [
                73
              ],
              "transparent": false
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/bombpack/special/explosion/frame-19.png",
              "bitmap_ids": [
                75
              ],
              "transparent": false
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/bombpack/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 77,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 17,
        "runtimeBallId": "171",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      }
    },
    {
      "id": "bomb",
      "pic": "bomb",
      "name": "轰天",
      "templateId": "7007",
      "baseDamage": 200,
      "attack": 40,
      "defence": 250,
      "agility": 30,
      "luck": 60,
      "minAngle": 55,
      "maxAngle": 75,
      "icon": "/game/weapons/bomb/icon.png",
      "held": "/game/weapons/bomb/held.png",
      "heldSheet": "/game/weapons/bomb/held-sheet.png",
      "heldAnchor": {
        "x": 62,
        "y": 83
      },
      "evidence": "Weapon family dated to 2009; original visuals and stats from later overseas archive; 2009 exact numerical/animation match pending",
      "laterArchiveAngles": [
        55,
        70
      ],
      "angleEvidence": {
        "status": "Dated 2009 official contemporary table takes precedence over later configuration",
        "sourceUrl": "https://web.4399.com/ddt/youxigonglue/200911/23-13312.html",
        "sourceFile": "research/source-inspection/weapon-audit/2009-nov-weapons.html"
      },
      "normal": {
        "power": 1.0,
        "radius": 55.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "bomb-normal",
        "runtimeCraterId": "101",
        "projectile": [
          "/game/weapons/bomb/normal/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-01.png",
          "/game/weapons/bomb/normal/explosion/frame-02.png",
          "/game/weapons/bomb/normal/explosion/frame-03.png",
          "/game/weapons/bomb/normal/explosion/frame-04.png",
          "/game/weapons/bomb/normal/explosion/frame-05.png",
          "/game/weapons/bomb/normal/explosion/frame-06.png",
          "/game/weapons/bomb/normal/explosion/frame-07.png",
          "/game/weapons/bomb/normal/explosion/frame-08.png",
          "/game/weapons/bomb/normal/explosion/frame-09.png",
          "/game/weapons/bomb/normal/explosion/frame-10.png",
          "/game/weapons/bomb/normal/explosion/frame-11.png",
          "/game/weapons/bomb/normal/explosion/frame-12.png",
          "/game/weapons/bomb/normal/explosion/frame-13.png",
          "/game/weapons/bomb/normal/explosion/frame-14.png",
          "/game/weapons/bomb/normal/explosion/frame-15.png",
          "/game/weapons/bomb/normal/explosion/frame-16.png",
          "/game/weapons/bomb/normal/explosion/frame-17.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png",
          "/game/weapons/bomb/normal/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/bomb/normal/crater.map",
        "crater": "/game/weapons/bomb/normal/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/bomb/normal/crater-mask.png",
        "craterTimeline": {
          "width": 156,
          "height": 118,
          "anchor": {
            "x": 78,
            "y": 59
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bomb/normal/border/frame-00.png",
              "bitmap_ids": [
                73
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 75,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 48,
          "height": 53,
          "anchor": {
            "x": 31,
            "y": 34
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bomb/normal/projectile/frame-00.png",
              "bitmap_ids": [
                80
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 82,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 513,
          "height": 513,
          "anchor": {
            "x": 253,
            "y": 235
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/bomb/normal/explosion/frame-01.png",
              "bitmap_ids": [
                38
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/bomb/normal/explosion/frame-02.png",
              "bitmap_ids": [
                40
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/bomb/normal/explosion/frame-03.png",
              "bitmap_ids": [
                42
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/bomb/normal/explosion/frame-04.png",
              "bitmap_ids": [
                44
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/bomb/normal/explosion/frame-05.png",
              "bitmap_ids": [
                46
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/bomb/normal/explosion/frame-06.png",
              "bitmap_ids": [
                48
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/bomb/normal/explosion/frame-07.png",
              "bitmap_ids": [
                50
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/bomb/normal/explosion/frame-08.png",
              "bitmap_ids": [
                52
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/bomb/normal/explosion/frame-09.png",
              "bitmap_ids": [
                54
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/bomb/normal/explosion/frame-10.png",
              "bitmap_ids": [
                56
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/bomb/normal/explosion/frame-11.png",
              "bitmap_ids": [
                58
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/bomb/normal/explosion/frame-12.png",
              "bitmap_ids": [
                60
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/bomb/normal/explosion/frame-13.png",
              "bitmap_ids": [
                62
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/bomb/normal/explosion/frame-14.png",
              "bitmap_ids": [
                64
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/bomb/normal/explosion/frame-15.png",
              "bitmap_ids": [
                66
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/bomb/normal/explosion/frame-16.png",
              "bitmap_ids": [
                68
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/bomb/normal/explosion/frame-17.png",
              "bitmap_ids": [
                70
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/bomb/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 72,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 10,
        "runtimeBallId": "101",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      },
      "special": {
        "power": 1.3,
        "radius": 65.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "bomb-special",
        "runtimeCraterId": "111",
        "projectile": [
          "/game/weapons/bomb/special/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-01.png",
          "/game/weapons/bomb/special/explosion/frame-02.png",
          "/game/weapons/bomb/special/explosion/frame-03.png",
          "/game/weapons/bomb/special/explosion/frame-04.png",
          "/game/weapons/bomb/special/explosion/frame-05.png",
          "/game/weapons/bomb/special/explosion/frame-06.png",
          "/game/weapons/bomb/special/explosion/frame-07.png",
          "/game/weapons/bomb/special/explosion/frame-08.png",
          "/game/weapons/bomb/special/explosion/frame-09.png",
          "/game/weapons/bomb/special/explosion/frame-10.png",
          "/game/weapons/bomb/special/explosion/frame-11.png",
          "/game/weapons/bomb/special/explosion/frame-12.png",
          "/game/weapons/bomb/special/explosion/frame-13.png",
          "/game/weapons/bomb/special/explosion/frame-14.png",
          "/game/weapons/bomb/special/explosion/frame-15.png",
          "/game/weapons/bomb/special/explosion/frame-16.png",
          "/game/weapons/bomb/special/explosion/frame-17.png",
          "/game/weapons/bomb/special/explosion/frame-18.png",
          "/game/weapons/bomb/special/explosion/frame-19.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png",
          "/game/weapons/bomb/special/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/bomb/special/crater.map",
        "crater": "/game/weapons/bomb/special/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/bomb/special/crater-mask.png",
        "craterTimeline": {
          "width": 170,
          "height": 136,
          "anchor": {
            "x": 85,
            "y": 68
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bomb/special/border/frame-00.png",
              "bitmap_ids": [
                77
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 79,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 59,
          "height": 32,
          "anchor": {
            "x": 45,
            "y": 16
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bomb/special/projectile/frame-00.png",
              "bitmap_ids": [
                84
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 86,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 513,
          "height": 513,
          "anchor": {
            "x": 266,
            "y": 210
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/bomb/special/explosion/frame-01.png",
              "bitmap_ids": [
                38
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/bomb/special/explosion/frame-02.png",
              "bitmap_ids": [
                40
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/bomb/special/explosion/frame-03.png",
              "bitmap_ids": [
                42
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/bomb/special/explosion/frame-04.png",
              "bitmap_ids": [
                44
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/bomb/special/explosion/frame-05.png",
              "bitmap_ids": [
                46
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/bomb/special/explosion/frame-06.png",
              "bitmap_ids": [
                48
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/bomb/special/explosion/frame-07.png",
              "bitmap_ids": [
                50
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/bomb/special/explosion/frame-08.png",
              "bitmap_ids": [
                52
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/bomb/special/explosion/frame-09.png",
              "bitmap_ids": [
                54
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/bomb/special/explosion/frame-10.png",
              "bitmap_ids": [
                56
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/bomb/special/explosion/frame-11.png",
              "bitmap_ids": [
                58
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/bomb/special/explosion/frame-12.png",
              "bitmap_ids": [
                60
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/bomb/special/explosion/frame-13.png",
              "bitmap_ids": [
                62
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/bomb/special/explosion/frame-14.png",
              "bitmap_ids": [
                64
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/bomb/special/explosion/frame-15.png",
              "bitmap_ids": [
                66
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/bomb/special/explosion/frame-16.png",
              "bitmap_ids": [
                68
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/bomb/special/explosion/frame-17.png",
              "bitmap_ids": [
                70
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/bomb/special/explosion/frame-18.png",
              "bitmap_ids": [
                72
              ],
              "transparent": false
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/bomb/special/explosion/frame-19.png",
              "bitmap_ids": [
                74
              ],
              "transparent": false
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/bomb/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 76,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 11,
        "runtimeBallId": "111",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      }
    },
    {
      "id": "dart",
      "pic": "dart",
      "name": "神风",
      "templateId": "7008",
      "baseDamage": 200,
      "attack": 60,
      "defence": 30,
      "agility": 250,
      "luck": 40,
      "minAngle": 10,
      "maxAngle": 40,
      "icon": "/game/weapons/dart/icon.png",
      "held": "/game/weapons/dart/held.png",
      "heldSheet": "/game/weapons/dart/held-sheet.png",
      "heldAnchor": {
        "x": 62,
        "y": 83
      },
      "evidence": "Weapon family dated to 2009; original visuals and stats from later overseas archive; 2009 exact numerical/animation match pending",
      "laterArchiveAngles": [
        15,
        50
      ],
      "angleEvidence": {
        "status": "Dated 2009 official contemporary table takes precedence over later configuration",
        "sourceUrl": "https://web.4399.com/ddt/youxigonglue/200911/23-13312.html",
        "sourceFile": "research/source-inspection/weapon-audit/2009-nov-weapons.html"
      },
      "normal": {
        "power": 1.0,
        "radius": 55.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "dart-normal",
        "runtimeCraterId": "121",
        "projectile": [
          "/game/weapons/dart/normal/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-01.png",
          "/game/weapons/dart/normal/explosion/frame-02.png",
          "/game/weapons/dart/normal/explosion/frame-03.png",
          "/game/weapons/dart/normal/explosion/frame-04.png",
          "/game/weapons/dart/normal/explosion/frame-05.png",
          "/game/weapons/dart/normal/explosion/frame-06.png",
          "/game/weapons/dart/normal/explosion/frame-07.png",
          "/game/weapons/dart/normal/explosion/frame-08.png",
          "/game/weapons/dart/normal/explosion/frame-09.png",
          "/game/weapons/dart/normal/explosion/frame-10.png",
          "/game/weapons/dart/normal/explosion/frame-11.png",
          "/game/weapons/dart/normal/explosion/frame-12.png",
          "/game/weapons/dart/normal/explosion/frame-13.png",
          "/game/weapons/dart/normal/explosion/frame-14.png",
          "/game/weapons/dart/normal/explosion/frame-15.png",
          "/game/weapons/dart/normal/explosion/frame-16.png",
          "/game/weapons/dart/normal/explosion/frame-17.png",
          "/game/weapons/dart/normal/explosion/frame-18.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png",
          "/game/weapons/dart/normal/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/dart/normal/crater.map",
        "crater": "/game/weapons/dart/normal/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/dart/normal/crater-mask.png",
        "craterTimeline": {
          "width": 128,
          "height": 92,
          "anchor": {
            "x": 64,
            "y": 46
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/dart/normal/border/frame-00.png",
              "bitmap_ids": [
                75
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 77,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 46,
          "height": 50,
          "anchor": {
            "x": 25,
            "y": 24
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/dart/normal/projectile/frame-00.png",
              "bitmap_ids": [
                82
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 84,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 339,
          "height": 276,
          "anchor": {
            "x": 197,
            "y": 132
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/dart/normal/explosion/frame-01.png",
              "bitmap_ids": [
                38
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/dart/normal/explosion/frame-02.png",
              "bitmap_ids": [
                40
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/dart/normal/explosion/frame-03.png",
              "bitmap_ids": [
                42
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/dart/normal/explosion/frame-04.png",
              "bitmap_ids": [
                44
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/dart/normal/explosion/frame-05.png",
              "bitmap_ids": [
                46
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/dart/normal/explosion/frame-06.png",
              "bitmap_ids": [
                48
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/dart/normal/explosion/frame-07.png",
              "bitmap_ids": [
                50
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/dart/normal/explosion/frame-08.png",
              "bitmap_ids": [
                52
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/dart/normal/explosion/frame-09.png",
              "bitmap_ids": [
                54
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/dart/normal/explosion/frame-10.png",
              "bitmap_ids": [
                56
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/dart/normal/explosion/frame-11.png",
              "bitmap_ids": [
                58
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/dart/normal/explosion/frame-12.png",
              "bitmap_ids": [
                60
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/dart/normal/explosion/frame-13.png",
              "bitmap_ids": [
                62
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/dart/normal/explosion/frame-14.png",
              "bitmap_ids": [
                64
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/dart/normal/explosion/frame-15.png",
              "bitmap_ids": [
                66
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/dart/normal/explosion/frame-16.png",
              "bitmap_ids": [
                68
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/dart/normal/explosion/frame-17.png",
              "bitmap_ids": [
                70
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/dart/normal/explosion/frame-18.png",
              "bitmap_ids": [
                72
              ],
              "transparent": false
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/dart/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 74,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 12,
        "runtimeBallId": "121",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      },
      "special": {
        "power": 1.5,
        "radius": 65.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "dart-special",
        "runtimeCraterId": "131",
        "projectile": [
          "/game/weapons/dart/special/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-01.png",
          "/game/weapons/dart/special/explosion/frame-02.png",
          "/game/weapons/dart/special/explosion/frame-03.png",
          "/game/weapons/dart/special/explosion/frame-04.png",
          "/game/weapons/dart/special/explosion/frame-05.png",
          "/game/weapons/dart/special/explosion/frame-06.png",
          "/game/weapons/dart/special/explosion/frame-07.png",
          "/game/weapons/dart/special/explosion/frame-08.png",
          "/game/weapons/dart/special/explosion/frame-09.png",
          "/game/weapons/dart/special/explosion/frame-10.png",
          "/game/weapons/dart/special/explosion/frame-11.png",
          "/game/weapons/dart/special/explosion/frame-12.png",
          "/game/weapons/dart/special/explosion/frame-13.png",
          "/game/weapons/dart/special/explosion/frame-14.png",
          "/game/weapons/dart/special/explosion/frame-15.png",
          "/game/weapons/dart/special/explosion/frame-16.png",
          "/game/weapons/dart/special/explosion/frame-17.png",
          "/game/weapons/dart/special/explosion/frame-18.png",
          "/game/weapons/dart/special/explosion/frame-19.png",
          "/game/weapons/dart/special/explosion/frame-20.png",
          "/game/weapons/dart/special/explosion/frame-21.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png",
          "/game/weapons/dart/special/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/dart/special/crater.map",
        "crater": "/game/weapons/dart/special/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/dart/special/crater-mask.png",
        "craterTimeline": {
          "width": 142,
          "height": 106,
          "anchor": {
            "x": 71,
            "y": 53
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/dart/special/border/frame-00.png",
              "bitmap_ids": [
                81
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 83,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 101,
          "height": 103,
          "anchor": {
            "x": 52,
            "y": 54
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/dart/special/projectile/frame-00.png",
              "bitmap_ids": [
                88
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 90,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 288,
          "height": 297,
          "anchor": {
            "x": 139,
            "y": 174
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/dart/special/explosion/frame-01.png",
              "bitmap_ids": [
                38
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/dart/special/explosion/frame-02.png",
              "bitmap_ids": [
                40
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/dart/special/explosion/frame-03.png",
              "bitmap_ids": [
                42
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/dart/special/explosion/frame-04.png",
              "bitmap_ids": [
                44
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/dart/special/explosion/frame-05.png",
              "bitmap_ids": [
                46
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/dart/special/explosion/frame-06.png",
              "bitmap_ids": [
                48
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/dart/special/explosion/frame-07.png",
              "bitmap_ids": [
                50
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/dart/special/explosion/frame-08.png",
              "bitmap_ids": [
                52
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/dart/special/explosion/frame-09.png",
              "bitmap_ids": [
                54
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/dart/special/explosion/frame-10.png",
              "bitmap_ids": [
                56
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/dart/special/explosion/frame-11.png",
              "bitmap_ids": [
                58
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/dart/special/explosion/frame-12.png",
              "bitmap_ids": [
                60
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/dart/special/explosion/frame-13.png",
              "bitmap_ids": [
                62
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/dart/special/explosion/frame-14.png",
              "bitmap_ids": [
                64
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/dart/special/explosion/frame-15.png",
              "bitmap_ids": [
                66
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/dart/special/explosion/frame-16.png",
              "bitmap_ids": [
                68
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/dart/special/explosion/frame-17.png",
              "bitmap_ids": [
                70
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/dart/special/explosion/frame-18.png",
              "bitmap_ids": [
                72
              ],
              "transparent": false
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/dart/special/explosion/frame-19.png",
              "bitmap_ids": [
                74
              ],
              "transparent": false
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/dart/special/explosion/frame-20.png",
              "bitmap_ids": [
                76
              ],
              "transparent": false
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/dart/special/explosion/frame-21.png",
              "bitmap_ids": [
                78
              ],
              "transparent": false
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/dart/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 80,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 13,
        "runtimeBallId": "131",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      }
    },
    {
      "id": "electricbar",
      "pic": "electricbar",
      "name": "雷霆",
      "templateId": "7009",
      "baseDamage": 200,
      "attack": 30,
      "defence": 40,
      "agility": 60,
      "luck": 250,
      "minAngle": 10,
      "maxAngle": 45,
      "icon": "/game/weapons/electricbar/icon.png",
      "held": "/game/weapons/electricbar/held.png",
      "heldSheet": "/game/weapons/electricbar/held-sheet.png",
      "heldAnchor": {
        "x": 62,
        "y": 83
      },
      "evidence": "Weapon family dated to 2009; original visuals and stats from later overseas archive; 2009 exact numerical/animation match pending",
      "laterArchiveAngles": [
        25,
        60
      ],
      "angleEvidence": {
        "status": "Dated 2009 official contemporary table takes precedence over later configuration",
        "sourceUrl": "https://web.4399.com/ddt/youxigonglue/200911/23-13312.html",
        "sourceFile": "research/source-inspection/weapon-audit/2009-nov-weapons.html"
      },
      "normal": {
        "power": 1.0,
        "radius": 55.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "electricbar-normal",
        "runtimeCraterId": "141",
        "projectile": [
          "/game/weapons/electricbar/normal/projectile/frame-00.png",
          "/game/weapons/electricbar/normal/projectile/frame-01.png",
          "/game/weapons/electricbar/normal/projectile/frame-02.png",
          "/game/weapons/electricbar/normal/projectile/frame-03.png",
          "/game/weapons/electricbar/normal/projectile/frame-04.png"
        ],
        "explosion": [
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-01.png",
          "/game/weapons/electricbar/normal/explosion/frame-02.png",
          "/game/weapons/electricbar/normal/explosion/frame-03.png",
          "/game/weapons/electricbar/normal/explosion/frame-04.png",
          "/game/weapons/electricbar/normal/explosion/frame-05.png",
          "/game/weapons/electricbar/normal/explosion/frame-06.png",
          "/game/weapons/electricbar/normal/explosion/frame-07.png",
          "/game/weapons/electricbar/normal/explosion/frame-08.png",
          "/game/weapons/electricbar/normal/explosion/frame-09.png",
          "/game/weapons/electricbar/normal/explosion/frame-10.png",
          "/game/weapons/electricbar/normal/explosion/frame-11.png",
          "/game/weapons/electricbar/normal/explosion/frame-12.png",
          "/game/weapons/electricbar/normal/explosion/frame-13.png",
          "/game/weapons/electricbar/normal/explosion/frame-14.png",
          "/game/weapons/electricbar/normal/explosion/frame-15.png",
          "/game/weapons/electricbar/normal/explosion/frame-16.png",
          "/game/weapons/electricbar/normal/explosion/frame-17.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png",
          "/game/weapons/electricbar/normal/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/electricbar/normal/crater.map",
        "crater": "/game/weapons/electricbar/normal/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/electricbar/normal/crater-mask.png",
        "craterTimeline": {
          "width": 126,
          "height": 110,
          "anchor": {
            "x": 63,
            "y": 55
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/electricbar/normal/border/frame-00.png",
              "bitmap_ids": [
                36
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 38,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 77,
          "height": 54,
          "anchor": {
            "x": 72,
            "y": 29
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/electricbar/normal/projectile/frame-00.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/electricbar/normal/projectile/frame-01.png",
              "bitmap_ids": [
                45
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/electricbar/normal/projectile/frame-02.png",
              "bitmap_ids": [
                47
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/electricbar/normal/projectile/frame-03.png",
              "bitmap_ids": [
                49
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/electricbar/normal/projectile/frame-04.png",
              "bitmap_ids": [
                51
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 53,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 276,
          "height": 276,
          "anchor": {
            "x": 137,
            "y": 137
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/electricbar/normal/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/electricbar/normal/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/electricbar/normal/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/electricbar/normal/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/electricbar/normal/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/electricbar/normal/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/electricbar/normal/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/electricbar/normal/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/electricbar/normal/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/electricbar/normal/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/electricbar/normal/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/electricbar/normal/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/electricbar/normal/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/electricbar/normal/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/electricbar/normal/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/electricbar/normal/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/electricbar/normal/explosion/frame-17.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/electricbar/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 35,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 14,
        "runtimeBallId": "141",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      },
      "special": {
        "power": 0.6,
        "radius": 65.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 3,
        "spin": 0,
        "craterId": "electricbar-special",
        "runtimeCraterId": "151",
        "projectile": [
          "/game/weapons/electricbar/special/projectile/frame-00.png",
          "/game/weapons/electricbar/special/projectile/frame-01.png",
          "/game/weapons/electricbar/special/projectile/frame-02.png",
          "/game/weapons/electricbar/special/projectile/frame-03.png",
          "/game/weapons/electricbar/special/projectile/frame-04.png"
        ],
        "explosion": [
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-01.png",
          "/game/weapons/electricbar/special/explosion/frame-02.png",
          "/game/weapons/electricbar/special/explosion/frame-03.png",
          "/game/weapons/electricbar/special/explosion/frame-04.png",
          "/game/weapons/electricbar/special/explosion/frame-05.png",
          "/game/weapons/electricbar/special/explosion/frame-06.png",
          "/game/weapons/electricbar/special/explosion/frame-07.png",
          "/game/weapons/electricbar/special/explosion/frame-08.png",
          "/game/weapons/electricbar/special/explosion/frame-08.png",
          "/game/weapons/electricbar/special/explosion/frame-10.png",
          "/game/weapons/electricbar/special/explosion/frame-11.png",
          "/game/weapons/electricbar/special/explosion/frame-12.png",
          "/game/weapons/electricbar/special/explosion/frame-13.png",
          "/game/weapons/electricbar/special/explosion/frame-14.png",
          "/game/weapons/electricbar/special/explosion/frame-15.png",
          "/game/weapons/electricbar/special/explosion/frame-16.png",
          "/game/weapons/electricbar/special/explosion/frame-17.png",
          "/game/weapons/electricbar/special/explosion/frame-18.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png",
          "/game/weapons/electricbar/special/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/electricbar/special/crater.map",
        "crater": "/game/weapons/electricbar/special/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/electricbar/special/crater-mask.png",
        "craterTimeline": {
          "width": 112,
          "height": 86,
          "anchor": {
            "x": 56,
            "y": 43
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/electricbar/special/border/frame-00.png",
              "bitmap_ids": [
                38
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 40,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 88,
          "height": 57,
          "anchor": {
            "x": 79,
            "y": 33
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/electricbar/special/projectile/frame-00.png",
              "bitmap_ids": [
                45
              ],
              "transparent": false
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/electricbar/special/projectile/frame-01.png",
              "bitmap_ids": [
                47
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/electricbar/special/projectile/frame-02.png",
              "bitmap_ids": [
                49
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/electricbar/special/projectile/frame-03.png",
              "bitmap_ids": [
                51
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/electricbar/special/projectile/frame-04.png",
              "bitmap_ids": [
                53
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 55,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 314,
          "height": 314,
          "anchor": {
            "x": 150,
            "y": 150
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/electricbar/special/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/electricbar/special/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/electricbar/special/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/electricbar/special/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/electricbar/special/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/electricbar/special/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/electricbar/special/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/electricbar/special/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/electricbar/special/explosion/frame-08.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/electricbar/special/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/electricbar/special/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/electricbar/special/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/electricbar/special/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/electricbar/special/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/electricbar/special/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/electricbar/special/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/electricbar/special/explosion/frame-17.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/electricbar/special/explosion/frame-18.png",
              "bitmap_ids": [
                35
              ],
              "transparent": false
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/electricbar/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 37,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 15,
        "runtimeBallId": "151",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      }
    },
    {
      "id": "brick",
      "pic": "brick",
      "name": "司马砸缸",
      "templateId": "7010",
      "baseDamage": 200,
      "attack": 180,
      "defence": 130,
      "agility": 30,
      "luck": 40,
      "minAngle": 20,
      "maxAngle": 60,
      "icon": "/game/weapons/brick/icon.png",
      "held": "/game/weapons/brick/held.png",
      "heldSheet": "/game/weapons/brick/held-sheet.png",
      "heldAnchor": {
        "x": 62,
        "y": 83
      },
      "evidence": "Weapon family dated to 2009; original visuals and stats from later overseas archive; 2009 exact numerical/animation match pending",
      "laterArchiveAngles": [
        20,
        65
      ],
      "angleEvidence": {
        "status": "Dated 2009 official contemporary table takes precedence over later configuration",
        "sourceUrl": "https://web.4399.com/ddt/youxigonglue/200911/23-13312.html",
        "sourceFile": "research/source-inspection/weapon-audit/2009-nov-weapons.html",
        "conflict": "Earlier research summary said 20–65; saved 2009-11-23 article explicitly says 20–60, so the original article is used."
      },
      "normal": {
        "power": 1.0,
        "radius": 55.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "brick-normal",
        "runtimeCraterId": "381",
        "projectile": [
          "/game/weapons/brick/normal/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-01.png",
          "/game/weapons/brick/normal/explosion/frame-02.png",
          "/game/weapons/brick/normal/explosion/frame-03.png",
          "/game/weapons/brick/normal/explosion/frame-04.png",
          "/game/weapons/brick/normal/explosion/frame-05.png",
          "/game/weapons/brick/normal/explosion/frame-06.png",
          "/game/weapons/brick/normal/explosion/frame-07.png",
          "/game/weapons/brick/normal/explosion/frame-08.png",
          "/game/weapons/brick/normal/explosion/frame-09.png",
          "/game/weapons/brick/normal/explosion/frame-10.png",
          "/game/weapons/brick/normal/explosion/frame-11.png",
          "/game/weapons/brick/normal/explosion/frame-12.png",
          "/game/weapons/brick/normal/explosion/frame-13.png",
          "/game/weapons/brick/normal/explosion/frame-14.png",
          "/game/weapons/brick/normal/explosion/frame-15.png",
          "/game/weapons/brick/normal/explosion/frame-16.png",
          "/game/weapons/brick/normal/explosion/frame-17.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png",
          "/game/weapons/brick/normal/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/brick/normal/crater.map",
        "crater": "/game/weapons/brick/normal/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/brick/normal/crater-mask.png",
        "craterTimeline": {
          "width": 122,
          "height": 88,
          "anchor": {
            "x": 61,
            "y": 44
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/brick/normal/border/frame-00.png",
              "bitmap_ids": [
                64
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 66,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 34,
          "height": 40,
          "anchor": {
            "x": 17,
            "y": 20
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/brick/normal/projectile/frame-00.png",
              "bitmap_ids": [
                71
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 73,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 293,
          "height": 289,
          "anchor": {
            "x": 149,
            "y": 97
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/brick/normal/explosion/frame-01.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/brick/normal/explosion/frame-02.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/brick/normal/explosion/frame-03.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/brick/normal/explosion/frame-04.png",
              "bitmap_ids": [
                35
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/brick/normal/explosion/frame-05.png",
              "bitmap_ids": [
                37
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/brick/normal/explosion/frame-06.png",
              "bitmap_ids": [
                39
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/brick/normal/explosion/frame-07.png",
              "bitmap_ids": [
                41
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/brick/normal/explosion/frame-08.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/brick/normal/explosion/frame-09.png",
              "bitmap_ids": [
                45
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/brick/normal/explosion/frame-10.png",
              "bitmap_ids": [
                47
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/brick/normal/explosion/frame-11.png",
              "bitmap_ids": [
                49
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/brick/normal/explosion/frame-12.png",
              "bitmap_ids": [
                51
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/brick/normal/explosion/frame-13.png",
              "bitmap_ids": [
                53
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/brick/normal/explosion/frame-14.png",
              "bitmap_ids": [
                55
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/brick/normal/explosion/frame-15.png",
              "bitmap_ids": [
                57
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/brick/normal/explosion/frame-16.png",
              "bitmap_ids": [
                59
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/brick/normal/explosion/frame-17.png",
              "bitmap_ids": [
                61
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/brick/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 63,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 38,
        "runtimeBallId": "381",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      },
      "special": {
        "power": 1.5,
        "radius": 65.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "brick-special",
        "runtimeCraterId": "391",
        "projectile": [
          "/game/weapons/brick/special/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-01.png",
          "/game/weapons/brick/special/explosion/frame-02.png",
          "/game/weapons/brick/special/explosion/frame-03.png",
          "/game/weapons/brick/special/explosion/frame-04.png",
          "/game/weapons/brick/special/explosion/frame-05.png",
          "/game/weapons/brick/special/explosion/frame-06.png",
          "/game/weapons/brick/special/explosion/frame-07.png",
          "/game/weapons/brick/special/explosion/frame-08.png",
          "/game/weapons/brick/special/explosion/frame-09.png",
          "/game/weapons/brick/special/explosion/frame-10.png",
          "/game/weapons/brick/special/explosion/frame-11.png",
          "/game/weapons/brick/special/explosion/frame-12.png",
          "/game/weapons/brick/special/explosion/frame-13.png",
          "/game/weapons/brick/special/explosion/frame-14.png",
          "/game/weapons/brick/special/explosion/frame-15.png",
          "/game/weapons/brick/special/explosion/frame-16.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png",
          "/game/weapons/brick/special/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/brick/special/crater.map",
        "crater": "/game/weapons/brick/special/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/brick/special/crater-mask.png",
        "craterTimeline": {
          "width": 146,
          "height": 106,
          "anchor": {
            "x": 73,
            "y": 53
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/brick/special/border/frame-00.png",
              "bitmap_ids": [
                79
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 81,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 56,
          "height": 56,
          "anchor": {
            "x": 28,
            "y": 28
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/brick/special/projectile/frame-00.png",
              "bitmap_ids": [
                86
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 88,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 323,
          "height": 371,
          "anchor": {
            "x": 165,
            "y": 169
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/brick/special/explosion/frame-01.png",
              "bitmap_ids": [
                46
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/brick/special/explosion/frame-02.png",
              "bitmap_ids": [
                48
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/brick/special/explosion/frame-03.png",
              "bitmap_ids": [
                50
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/brick/special/explosion/frame-04.png",
              "bitmap_ids": [
                52
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/brick/special/explosion/frame-05.png",
              "bitmap_ids": [
                54
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/brick/special/explosion/frame-06.png",
              "bitmap_ids": [
                56
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/brick/special/explosion/frame-07.png",
              "bitmap_ids": [
                58
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/brick/special/explosion/frame-08.png",
              "bitmap_ids": [
                60
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/brick/special/explosion/frame-09.png",
              "bitmap_ids": [
                62
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/brick/special/explosion/frame-10.png",
              "bitmap_ids": [
                64
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/brick/special/explosion/frame-11.png",
              "bitmap_ids": [
                66
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/brick/special/explosion/frame-12.png",
              "bitmap_ids": [
                68
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/brick/special/explosion/frame-13.png",
              "bitmap_ids": [
                70
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/brick/special/explosion/frame-14.png",
              "bitmap_ids": [
                72
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/brick/special/explosion/frame-15.png",
              "bitmap_ids": [
                74
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/brick/special/explosion/frame-16.png",
              "bitmap_ids": [
                76
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/brick/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 78,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 39,
        "runtimeBallId": "391",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      }
    },
    {
      "id": "fruit",
      "pic": "fruit",
      "name": "牛顿水果篮",
      "templateId": "7011",
      "baseDamage": 200,
      "attack": 40,
      "defence": 30,
      "agility": 130,
      "luck": 180,
      "minAngle": 20,
      "maxAngle": 50,
      "icon": "/game/weapons/fruit/icon.png",
      "held": "/game/weapons/fruit/held.png",
      "heldSheet": "/game/weapons/fruit/held-sheet.png",
      "heldAnchor": {
        "x": 62,
        "y": 83
      },
      "evidence": "Weapon family dated to 2009; original visuals and stats from later overseas archive; 2009 exact numerical/animation match pending",
      "laterArchiveAngles": [
        20,
        65
      ],
      "angleEvidence": {
        "status": "Dated 2009 official contemporary table takes precedence over later configuration",
        "sourceUrl": "https://web.4399.com/ddt/youxigonglue/200911/23-13312.html",
        "sourceFile": "research/source-inspection/weapon-audit/2009-nov-weapons.html"
      },
      "normal": {
        "power": 1.0,
        "radius": 55.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "fruit-normal",
        "runtimeCraterId": "401",
        "projectile": [
          "/game/weapons/fruit/normal/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-01.png",
          "/game/weapons/fruit/normal/explosion/frame-02.png",
          "/game/weapons/fruit/normal/explosion/frame-03.png",
          "/game/weapons/fruit/normal/explosion/frame-04.png",
          "/game/weapons/fruit/normal/explosion/frame-05.png",
          "/game/weapons/fruit/normal/explosion/frame-06.png",
          "/game/weapons/fruit/normal/explosion/frame-07.png",
          "/game/weapons/fruit/normal/explosion/frame-08.png",
          "/game/weapons/fruit/normal/explosion/frame-09.png",
          "/game/weapons/fruit/normal/explosion/frame-10.png",
          "/game/weapons/fruit/normal/explosion/frame-11.png",
          "/game/weapons/fruit/normal/explosion/frame-12.png",
          "/game/weapons/fruit/normal/explosion/frame-13.png",
          "/game/weapons/fruit/normal/explosion/frame-14.png",
          "/game/weapons/fruit/normal/explosion/frame-15.png",
          "/game/weapons/fruit/normal/explosion/frame-16.png",
          "/game/weapons/fruit/normal/explosion/frame-17.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png",
          "/game/weapons/fruit/normal/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/fruit/normal/crater.map",
        "crater": "/game/weapons/fruit/normal/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/fruit/normal/crater-mask.png",
        "craterTimeline": {
          "width": 104,
          "height": 90,
          "anchor": {
            "x": 52,
            "y": 45
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/fruit/normal/border/frame-00.png",
              "bitmap_ids": [
                36
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 38,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 33,
          "height": 31,
          "anchor": {
            "x": 15,
            "y": 15
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/fruit/normal/projectile/frame-00.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 45,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 268,
          "height": 234,
          "anchor": {
            "x": 149,
            "y": 114
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/fruit/normal/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/fruit/normal/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/fruit/normal/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/fruit/normal/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/fruit/normal/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/fruit/normal/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/fruit/normal/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/fruit/normal/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/fruit/normal/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/fruit/normal/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/fruit/normal/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/fruit/normal/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/fruit/normal/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/fruit/normal/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/fruit/normal/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/fruit/normal/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/fruit/normal/explosion/frame-17.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 52,
              "url": "/game/weapons/fruit/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 35,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 40,
        "runtimeBallId": "401",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      },
      "special": {
        "power": 0.5,
        "radius": 65.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 3,
        "spin": 0,
        "craterId": "fruit-special",
        "runtimeCraterId": "411",
        "projectile": [
          "/game/weapons/fruit/special/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-01.png",
          "/game/weapons/fruit/special/explosion/frame-02.png",
          "/game/weapons/fruit/special/explosion/frame-03.png",
          "/game/weapons/fruit/special/explosion/frame-04.png",
          "/game/weapons/fruit/special/explosion/frame-05.png",
          "/game/weapons/fruit/special/explosion/frame-06.png",
          "/game/weapons/fruit/special/explosion/frame-07.png",
          "/game/weapons/fruit/special/explosion/frame-08.png",
          "/game/weapons/fruit/special/explosion/frame-09.png",
          "/game/weapons/fruit/special/explosion/frame-10.png",
          "/game/weapons/fruit/special/explosion/frame-11.png",
          "/game/weapons/fruit/special/explosion/frame-12.png",
          "/game/weapons/fruit/special/explosion/frame-13.png",
          "/game/weapons/fruit/special/explosion/frame-14.png",
          "/game/weapons/fruit/special/explosion/frame-15.png",
          "/game/weapons/fruit/special/explosion/frame-16.png",
          "/game/weapons/fruit/special/explosion/frame-17.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png",
          "/game/weapons/fruit/special/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/fruit/special/crater.map",
        "crater": "/game/weapons/fruit/special/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/fruit/special/crater-mask.png",
        "craterTimeline": {
          "width": 134,
          "height": 116,
          "anchor": {
            "x": 67,
            "y": 58
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/fruit/special/border/frame-00.png",
              "bitmap_ids": [
                56
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 58,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 52,
          "height": 52,
          "anchor": {
            "x": 26,
            "y": 26
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/fruit/special/projectile/frame-00.png",
              "bitmap_ids": [
                63
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 65,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 304,
          "height": 304,
          "anchor": {
            "x": 151,
            "y": 130
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/fruit/special/explosion/frame-01.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/fruit/special/explosion/frame-02.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/fruit/special/explosion/frame-03.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/fruit/special/explosion/frame-04.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/fruit/special/explosion/frame-05.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/fruit/special/explosion/frame-06.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/fruit/special/explosion/frame-07.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/fruit/special/explosion/frame-08.png",
              "bitmap_ids": [
                35
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/fruit/special/explosion/frame-09.png",
              "bitmap_ids": [
                37
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/fruit/special/explosion/frame-10.png",
              "bitmap_ids": [
                39
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/fruit/special/explosion/frame-11.png",
              "bitmap_ids": [
                41
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/fruit/special/explosion/frame-12.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/fruit/special/explosion/frame-13.png",
              "bitmap_ids": [
                45
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/fruit/special/explosion/frame-14.png",
              "bitmap_ids": [
                47
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/fruit/special/explosion/frame-15.png",
              "bitmap_ids": [
                49
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/fruit/special/explosion/frame-16.png",
              "bitmap_ids": [
                51
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/fruit/special/explosion/frame-17.png",
              "bitmap_ids": [
                53
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/fruit/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 55,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 41,
        "runtimeBallId": "411",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      }
    },
    {
      "id": "OPSbox",
      "pic": "OPSbox",
      "name": "医用工具箱",
      "templateId": "7012",
      "baseDamage": 200,
      "attack": 130,
      "defence": 30,
      "agility": 180,
      "luck": 40,
      "minAngle": 10,
      "maxAngle": 35,
      "icon": "/game/weapons/OPSbox/icon.png",
      "held": "/game/weapons/OPSbox/held.png",
      "heldSheet": "/game/weapons/OPSbox/held-sheet.png",
      "heldAnchor": {
        "x": 62,
        "y": 83
      },
      "evidence": "Weapon family dated to 2009; original visuals and stats from later overseas archive; 2009 exact numerical/animation match pending",
      "laterArchiveAngles": [
        15,
        60
      ],
      "angleEvidence": {
        "status": "Dated 2009 official contemporary table takes precedence over later configuration",
        "sourceUrl": "https://web.4399.com/ddt/youxigonglue/200911/23-13312.html",
        "sourceFile": "research/source-inspection/weapon-audit/2009-nov-weapons.html"
      },
      "normal": {
        "power": 1.0,
        "radius": 55.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "OPSbox-normal",
        "runtimeCraterId": "341",
        "projectile": [
          "/game/weapons/OPSbox/normal/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-01.png",
          "/game/weapons/OPSbox/normal/explosion/frame-02.png",
          "/game/weapons/OPSbox/normal/explosion/frame-03.png",
          "/game/weapons/OPSbox/normal/explosion/frame-04.png",
          "/game/weapons/OPSbox/normal/explosion/frame-05.png",
          "/game/weapons/OPSbox/normal/explosion/frame-06.png",
          "/game/weapons/OPSbox/normal/explosion/frame-07.png",
          "/game/weapons/OPSbox/normal/explosion/frame-08.png",
          "/game/weapons/OPSbox/normal/explosion/frame-09.png",
          "/game/weapons/OPSbox/normal/explosion/frame-10.png",
          "/game/weapons/OPSbox/normal/explosion/frame-11.png",
          "/game/weapons/OPSbox/normal/explosion/frame-12.png",
          "/game/weapons/OPSbox/normal/explosion/frame-13.png",
          "/game/weapons/OPSbox/normal/explosion/frame-14.png",
          "/game/weapons/OPSbox/normal/explosion/frame-15.png",
          "/game/weapons/OPSbox/normal/explosion/frame-16.png",
          "/game/weapons/OPSbox/normal/explosion/frame-17.png",
          "/game/weapons/OPSbox/normal/explosion/frame-18.png",
          "/game/weapons/OPSbox/normal/explosion/frame-19.png",
          "/game/weapons/OPSbox/normal/explosion/frame-20.png",
          "/game/weapons/OPSbox/normal/explosion/frame-21.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png",
          "/game/weapons/OPSbox/normal/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/OPSbox/normal/crater.map",
        "crater": "/game/weapons/OPSbox/normal/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/OPSbox/normal/crater-mask.png",
        "craterTimeline": {
          "width": 114,
          "height": 102,
          "anchor": {
            "x": 57,
            "y": 51
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/OPSbox/normal/border/frame-00.png",
              "bitmap_ids": [
                83
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 85,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 56,
          "height": 43,
          "anchor": {
            "x": 50,
            "y": 21
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/OPSbox/normal/projectile/frame-00.png",
              "bitmap_ids": [
                90
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 92,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 260,
          "height": 260,
          "anchor": {
            "x": 133,
            "y": 128
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-01.png",
              "bitmap_ids": [
                40
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-02.png",
              "bitmap_ids": [
                42
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-03.png",
              "bitmap_ids": [
                44
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-04.png",
              "bitmap_ids": [
                46
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-05.png",
              "bitmap_ids": [
                48
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-06.png",
              "bitmap_ids": [
                50
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-07.png",
              "bitmap_ids": [
                52
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-08.png",
              "bitmap_ids": [
                54
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-09.png",
              "bitmap_ids": [
                56
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-10.png",
              "bitmap_ids": [
                58
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-11.png",
              "bitmap_ids": [
                60
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-12.png",
              "bitmap_ids": [
                62
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-13.png",
              "bitmap_ids": [
                64
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-14.png",
              "bitmap_ids": [
                66
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-15.png",
              "bitmap_ids": [
                68
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-16.png",
              "bitmap_ids": [
                70
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-17.png",
              "bitmap_ids": [
                72
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-18.png",
              "bitmap_ids": [
                74
              ],
              "transparent": false
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-19.png",
              "bitmap_ids": [
                76
              ],
              "transparent": false
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-20.png",
              "bitmap_ids": [
                78
              ],
              "transparent": false
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-21.png",
              "bitmap_ids": [
                80
              ],
              "transparent": false
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/OPSbox/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 82,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 34,
        "runtimeBallId": "341",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      },
      "special": {
        "power": 1.5,
        "radius": 65.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "OPSbox-special",
        "runtimeCraterId": "351",
        "projectile": [
          "/game/weapons/OPSbox/special/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-01.png",
          "/game/weapons/OPSbox/special/explosion/frame-02.png",
          "/game/weapons/OPSbox/special/explosion/frame-03.png",
          "/game/weapons/OPSbox/special/explosion/frame-04.png",
          "/game/weapons/OPSbox/special/explosion/frame-05.png",
          "/game/weapons/OPSbox/special/explosion/frame-06.png",
          "/game/weapons/OPSbox/special/explosion/frame-07.png",
          "/game/weapons/OPSbox/special/explosion/frame-08.png",
          "/game/weapons/OPSbox/special/explosion/frame-09.png",
          "/game/weapons/OPSbox/special/explosion/frame-10.png",
          "/game/weapons/OPSbox/special/explosion/frame-11.png",
          "/game/weapons/OPSbox/special/explosion/frame-12.png",
          "/game/weapons/OPSbox/special/explosion/frame-13.png",
          "/game/weapons/OPSbox/special/explosion/frame-14.png",
          "/game/weapons/OPSbox/special/explosion/frame-15.png",
          "/game/weapons/OPSbox/special/explosion/frame-16.png",
          "/game/weapons/OPSbox/special/explosion/frame-17.png",
          "/game/weapons/OPSbox/special/explosion/frame-18.png",
          "/game/weapons/OPSbox/special/explosion/frame-19.png",
          "/game/weapons/OPSbox/special/explosion/frame-20.png",
          "/game/weapons/OPSbox/special/explosion/frame-21.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png",
          "/game/weapons/OPSbox/special/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/OPSbox/special/crater.map",
        "crater": "/game/weapons/OPSbox/special/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/OPSbox/special/crater-mask.png",
        "craterTimeline": {
          "width": 134,
          "height": 120,
          "anchor": {
            "x": 67,
            "y": 60
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/OPSbox/special/border/frame-00.png",
              "bitmap_ids": [
                83
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 85,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 80,
          "height": 75,
          "anchor": {
            "x": 54,
            "y": 44
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/OPSbox/special/projectile/frame-00.png",
              "bitmap_ids": [
                90
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 92,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 329,
          "height": 329,
          "anchor": {
            "x": 170,
            "y": 163
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/OPSbox/special/explosion/frame-01.png",
              "bitmap_ids": [
                40
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/OPSbox/special/explosion/frame-02.png",
              "bitmap_ids": [
                42
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/OPSbox/special/explosion/frame-03.png",
              "bitmap_ids": [
                44
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/OPSbox/special/explosion/frame-04.png",
              "bitmap_ids": [
                46
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/OPSbox/special/explosion/frame-05.png",
              "bitmap_ids": [
                48
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/OPSbox/special/explosion/frame-06.png",
              "bitmap_ids": [
                50
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/OPSbox/special/explosion/frame-07.png",
              "bitmap_ids": [
                52
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/OPSbox/special/explosion/frame-08.png",
              "bitmap_ids": [
                54
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/OPSbox/special/explosion/frame-09.png",
              "bitmap_ids": [
                56
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/OPSbox/special/explosion/frame-10.png",
              "bitmap_ids": [
                58
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/OPSbox/special/explosion/frame-11.png",
              "bitmap_ids": [
                60
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/OPSbox/special/explosion/frame-12.png",
              "bitmap_ids": [
                62
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/OPSbox/special/explosion/frame-13.png",
              "bitmap_ids": [
                64
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/OPSbox/special/explosion/frame-14.png",
              "bitmap_ids": [
                66
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/OPSbox/special/explosion/frame-15.png",
              "bitmap_ids": [
                68
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/OPSbox/special/explosion/frame-16.png",
              "bitmap_ids": [
                70
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/OPSbox/special/explosion/frame-17.png",
              "bitmap_ids": [
                72
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/OPSbox/special/explosion/frame-18.png",
              "bitmap_ids": [
                74
              ],
              "transparent": false
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/OPSbox/special/explosion/frame-19.png",
              "bitmap_ids": [
                76
              ],
              "transparent": false
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/OPSbox/special/explosion/frame-20.png",
              "bitmap_ids": [
                78
              ],
              "transparent": false
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/OPSbox/special/explosion/frame-21.png",
              "bitmap_ids": [
                80
              ],
              "transparent": false
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/OPSbox/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 82,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 35,
        "runtimeBallId": "351",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      }
    },
    {
      "id": "closestool",
      "pic": "closestool",
      "name": "畅通利器",
      "templateId": "7013",
      "baseDamage": 200,
      "attack": 40,
      "defence": 180,
      "agility": 30,
      "luck": 130,
      "minAngle": 20,
      "maxAngle": 45,
      "icon": "/game/weapons/closestool/icon.png",
      "held": "/game/weapons/closestool/held.png",
      "heldSheet": "/game/weapons/closestool/held-sheet.png",
      "heldAnchor": {
        "x": 62,
        "y": 83
      },
      "evidence": "Weapon family dated to 2009; original visuals and stats from later overseas archive; 2009 exact numerical/animation match pending",
      "laterArchiveAngles": [
        20,
        65
      ],
      "angleEvidence": {
        "status": "Dated 2009 official contemporary table takes precedence over later configuration",
        "sourceUrl": "https://web.4399.com/ddt/youxigonglue/200911/23-13312.html",
        "sourceFile": "research/source-inspection/weapon-audit/2009-nov-weapons.html"
      },
      "normal": {
        "power": 1.0,
        "radius": 55.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "closestool-normal",
        "runtimeCraterId": "361",
        "projectile": [
          "/game/weapons/closestool/normal/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-01.png",
          "/game/weapons/closestool/normal/explosion/frame-02.png",
          "/game/weapons/closestool/normal/explosion/frame-03.png",
          "/game/weapons/closestool/normal/explosion/frame-04.png",
          "/game/weapons/closestool/normal/explosion/frame-05.png",
          "/game/weapons/closestool/normal/explosion/frame-06.png",
          "/game/weapons/closestool/normal/explosion/frame-07.png",
          "/game/weapons/closestool/normal/explosion/frame-08.png",
          "/game/weapons/closestool/normal/explosion/frame-09.png",
          "/game/weapons/closestool/normal/explosion/frame-10.png",
          "/game/weapons/closestool/normal/explosion/frame-11.png",
          "/game/weapons/closestool/normal/explosion/frame-12.png",
          "/game/weapons/closestool/normal/explosion/frame-13.png",
          "/game/weapons/closestool/normal/explosion/frame-14.png",
          "/game/weapons/closestool/normal/explosion/frame-15.png",
          "/game/weapons/closestool/normal/explosion/frame-16.png",
          "/game/weapons/closestool/normal/explosion/frame-17.png",
          "/game/weapons/closestool/normal/explosion/frame-18.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png",
          "/game/weapons/closestool/normal/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/closestool/normal/crater.map",
        "crater": "/game/weapons/closestool/normal/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/closestool/normal/crater-mask.png",
        "craterTimeline": {
          "width": 114,
          "height": 102,
          "anchor": {
            "x": 57,
            "y": 51
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/closestool/normal/border/frame-00.png",
              "bitmap_ids": [
                38
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 40,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 60,
          "height": 53,
          "anchor": {
            "x": 40,
            "y": 23
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/closestool/normal/projectile/frame-00.png",
              "bitmap_ids": [
                45
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 47,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 274,
          "height": 262,
          "anchor": {
            "x": 135,
            "y": 129
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/closestool/normal/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/closestool/normal/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/closestool/normal/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/closestool/normal/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/closestool/normal/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/closestool/normal/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/closestool/normal/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/closestool/normal/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/closestool/normal/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/closestool/normal/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/closestool/normal/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/closestool/normal/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/closestool/normal/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/closestool/normal/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/closestool/normal/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/closestool/normal/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/closestool/normal/explosion/frame-17.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/closestool/normal/explosion/frame-18.png",
              "bitmap_ids": [
                35
              ],
              "transparent": false
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/closestool/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 37,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 36,
        "runtimeBallId": "361",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      },
      "special": {
        "power": 0.5,
        "radius": 65.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 3,
        "spin": 0,
        "craterId": "closestool-special",
        "runtimeCraterId": "371",
        "projectile": [
          "/game/weapons/closestool/special/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-01.png",
          "/game/weapons/closestool/special/explosion/frame-02.png",
          "/game/weapons/closestool/special/explosion/frame-03.png",
          "/game/weapons/closestool/special/explosion/frame-04.png",
          "/game/weapons/closestool/special/explosion/frame-05.png",
          "/game/weapons/closestool/special/explosion/frame-06.png",
          "/game/weapons/closestool/special/explosion/frame-07.png",
          "/game/weapons/closestool/special/explosion/frame-08.png",
          "/game/weapons/closestool/special/explosion/frame-09.png",
          "/game/weapons/closestool/special/explosion/frame-10.png",
          "/game/weapons/closestool/special/explosion/frame-11.png",
          "/game/weapons/closestool/special/explosion/frame-12.png",
          "/game/weapons/closestool/special/explosion/frame-13.png",
          "/game/weapons/closestool/special/explosion/frame-14.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png",
          "/game/weapons/closestool/special/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/closestool/special/crater.map",
        "crater": "/game/weapons/closestool/special/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/closestool/special/crater-mask.png",
        "craterTimeline": {
          "width": 102,
          "height": 87,
          "anchor": {
            "x": 51,
            "y": 43
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/closestool/special/border/frame-00.png",
              "bitmap_ids": [
                34
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 36,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 47,
          "height": 47,
          "anchor": {
            "x": 24,
            "y": 24
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/closestool/special/projectile/frame-00.png",
              "bitmap_ids": [
                41
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 43,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 318,
          "height": 296,
          "anchor": {
            "x": 160,
            "y": 133
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/closestool/special/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/closestool/special/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/closestool/special/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/closestool/special/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/closestool/special/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/closestool/special/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/closestool/special/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/closestool/special/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/closestool/special/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/closestool/special/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/closestool/special/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/closestool/special/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/closestool/special/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/closestool/special/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [
                29
              ],
              "transparent": true
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [
                31
              ],
              "transparent": true
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/closestool/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 33,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 37,
        "runtimeBallId": "371",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      }
    },
    {
      "id": "television",
      "pic": "television",
      "name": "黑白家电",
      "templateId": "7014",
      "baseDamage": 200,
      "attack": 95,
      "defence": 95,
      "agility": 95,
      "luck": 95,
      "minAngle": 50,
      "maxAngle": 70,
      "icon": "/game/weapons/television/icon.png",
      "held": "/game/weapons/television/held.png",
      "heldSheet": "/game/weapons/television/held-sheet.png",
      "heldAnchor": {
        "x": 62,
        "y": 83
      },
      "evidence": "Weapon family dated to 2009; original visuals and stats from later overseas archive; 2009 exact numerical/animation match pending",
      "laterArchiveAngles": [
        50,
        70
      ],
      "angleEvidence": {
        "status": "Dated 2009 official contemporary table takes precedence over later configuration",
        "sourceUrl": "https://web.4399.com/ddt/youxigonglue/200911/23-13312.html",
        "sourceFile": "research/source-inspection/weapon-audit/2009-nov-weapons.html"
      },
      "normal": {
        "power": 1.0,
        "radius": 55.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "television-normal",
        "runtimeCraterId": "321",
        "projectile": [
          "/game/weapons/television/normal/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-01.png",
          "/game/weapons/television/normal/explosion/frame-02.png",
          "/game/weapons/television/normal/explosion/frame-03.png",
          "/game/weapons/television/normal/explosion/frame-04.png",
          "/game/weapons/television/normal/explosion/frame-05.png",
          "/game/weapons/television/normal/explosion/frame-06.png",
          "/game/weapons/television/normal/explosion/frame-07.png",
          "/game/weapons/television/normal/explosion/frame-08.png",
          "/game/weapons/television/normal/explosion/frame-09.png",
          "/game/weapons/television/normal/explosion/frame-10.png",
          "/game/weapons/television/normal/explosion/frame-11.png",
          "/game/weapons/television/normal/explosion/frame-12.png",
          "/game/weapons/television/normal/explosion/frame-13.png",
          "/game/weapons/television/normal/explosion/frame-14.png",
          "/game/weapons/television/normal/explosion/frame-15.png",
          "/game/weapons/television/normal/explosion/frame-16.png",
          "/game/weapons/television/normal/explosion/frame-17.png",
          "/game/weapons/television/normal/explosion/frame-18.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png",
          "/game/weapons/television/normal/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/television/normal/crater.map",
        "crater": "/game/weapons/television/normal/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/television/normal/crater-mask.png",
        "craterTimeline": {
          "width": 122,
          "height": 88,
          "anchor": {
            "x": 61,
            "y": 44
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/television/normal/border/frame-00.png",
              "bitmap_ids": [
                38
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 40,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 45,
          "height": 50,
          "anchor": {
            "x": 22,
            "y": 24
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/television/normal/projectile/frame-00.png",
              "bitmap_ids": [
                45
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 47,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 270,
          "height": 243,
          "anchor": {
            "x": 134,
            "y": 123
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/television/normal/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/television/normal/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/television/normal/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/television/normal/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/television/normal/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/television/normal/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/television/normal/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/television/normal/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/television/normal/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/television/normal/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/television/normal/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/television/normal/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/television/normal/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/television/normal/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/television/normal/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/television/normal/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/television/normal/explosion/frame-17.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/television/normal/explosion/frame-18.png",
              "bitmap_ids": [
                35
              ],
              "transparent": false
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/television/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 37,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 32,
        "runtimeBallId": "321",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      },
      "special": {
        "power": 1.5,
        "radius": 65.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "television-special",
        "runtimeCraterId": "331",
        "projectile": [
          "/game/weapons/television/special/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-01.png",
          "/game/weapons/television/special/explosion/frame-02.png",
          "/game/weapons/television/special/explosion/frame-03.png",
          "/game/weapons/television/special/explosion/frame-04.png",
          "/game/weapons/television/special/explosion/frame-05.png",
          "/game/weapons/television/special/explosion/frame-06.png",
          "/game/weapons/television/special/explosion/frame-07.png",
          "/game/weapons/television/special/explosion/frame-08.png",
          "/game/weapons/television/special/explosion/frame-09.png",
          "/game/weapons/television/special/explosion/frame-10.png",
          "/game/weapons/television/special/explosion/frame-11.png",
          "/game/weapons/television/special/explosion/frame-12.png",
          "/game/weapons/television/special/explosion/frame-13.png",
          "/game/weapons/television/special/explosion/frame-14.png",
          "/game/weapons/television/special/explosion/frame-15.png",
          "/game/weapons/television/special/explosion/frame-16.png",
          "/game/weapons/television/special/explosion/frame-17.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png",
          "/game/weapons/television/special/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/television/special/crater.map",
        "crater": "/game/weapons/television/special/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/television/special/crater-mask.png",
        "craterTimeline": {
          "width": 134,
          "height": 98,
          "anchor": {
            "x": 67,
            "y": 49
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/television/special/border/frame-00.png",
              "bitmap_ids": [
                36
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 38,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 52,
          "height": 68,
          "anchor": {
            "x": 26,
            "y": 34
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/television/special/projectile/frame-00.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 45,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 381,
          "height": 343,
          "anchor": {
            "x": 184,
            "y": 158
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/television/special/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/television/special/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/television/special/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/television/special/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/television/special/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/television/special/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/television/special/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/television/special/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/television/special/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/television/special/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/television/special/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/television/special/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/television/special/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/television/special/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/television/special/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/television/special/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/television/special/explosion/frame-17.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/television/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 35,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 33,
        "runtimeBallId": "331",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      }
    },
    {
      "id": "axe",
      "pic": "axe",
      "name": "碎石斧",
      "templateId": "7001",
      "baseDamage": 175,
      "attack": 16,
      "defence": 100,
      "agility": 10,
      "luck": 24,
      "minAngle": 25,
      "maxAngle": 60,
      "icon": "/game/weapons/axe/icon.png",
      "held": "/game/weapons/axe/held.png",
      "heldSheet": "/game/weapons/axe/held-sheet.png",
      "heldAnchor": {
        "x": 62,
        "y": 83
      },
      "evidence": "Weapon family dated to 2009; original visuals and stats from later overseas archive; 2009 exact numerical/animation match pending",
      "angleEvidence": {
        "status": "Later archive candidate; exact 2009 angle range not confirmed"
      },
      "normal": {
        "power": 1.0,
        "radius": 55.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "axe-normal",
        "runtimeCraterId": "20",
        "projectile": [
          "/game/weapons/axe/normal/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-01.png",
          "/game/weapons/axe/normal/explosion/frame-02.png",
          "/game/weapons/axe/normal/explosion/frame-03.png",
          "/game/weapons/axe/normal/explosion/frame-04.png",
          "/game/weapons/axe/normal/explosion/frame-05.png",
          "/game/weapons/axe/normal/explosion/frame-06.png",
          "/game/weapons/axe/normal/explosion/frame-07.png",
          "/game/weapons/axe/normal/explosion/frame-08.png",
          "/game/weapons/axe/normal/explosion/frame-09.png",
          "/game/weapons/axe/normal/explosion/frame-10.png",
          "/game/weapons/axe/normal/explosion/frame-11.png",
          "/game/weapons/axe/normal/explosion/frame-12.png",
          "/game/weapons/axe/normal/explosion/frame-13.png",
          "/game/weapons/axe/normal/explosion/frame-14.png",
          "/game/weapons/axe/normal/explosion/frame-15.png",
          "/game/weapons/axe/normal/explosion/frame-16.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png",
          "/game/weapons/axe/normal/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/axe/normal/crater.map",
        "crater": "/game/weapons/axe/normal/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/axe/normal/crater-mask.png",
        "craterTimeline": {
          "width": 122,
          "height": 78,
          "anchor": {
            "x": 61,
            "y": 39
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/axe/normal/border/frame-00.png",
              "bitmap_ids": [
                36
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 38,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 49,
          "height": 45,
          "anchor": {
            "x": 24,
            "y": 25
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/axe/normal/projectile/frame-00.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 44,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 329,
          "height": 245,
          "anchor": {
            "x": 162,
            "y": 121
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/axe/normal/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/axe/normal/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/axe/normal/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/axe/normal/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/axe/normal/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/axe/normal/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/axe/normal/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/axe/normal/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/axe/normal/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/axe/normal/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/axe/normal/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/axe/normal/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/axe/normal/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/axe/normal/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/axe/normal/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/axe/normal/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [
                33
              ],
              "transparent": true
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/axe/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 35,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 20,
        "runtimeBallId": "20",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      },
      "special": {
        "power": 1.5,
        "radius": 65.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "axe-special",
        "runtimeCraterId": "20",
        "projectile": [
          "/game/weapons/axe/special/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-01.png",
          "/game/weapons/axe/special/explosion/frame-02.png",
          "/game/weapons/axe/special/explosion/frame-03.png",
          "/game/weapons/axe/special/explosion/frame-04.png",
          "/game/weapons/axe/special/explosion/frame-05.png",
          "/game/weapons/axe/special/explosion/frame-06.png",
          "/game/weapons/axe/special/explosion/frame-07.png",
          "/game/weapons/axe/special/explosion/frame-08.png",
          "/game/weapons/axe/special/explosion/frame-09.png",
          "/game/weapons/axe/special/explosion/frame-10.png",
          "/game/weapons/axe/special/explosion/frame-11.png",
          "/game/weapons/axe/special/explosion/frame-12.png",
          "/game/weapons/axe/special/explosion/frame-13.png",
          "/game/weapons/axe/special/explosion/frame-14.png",
          "/game/weapons/axe/special/explosion/frame-15.png",
          "/game/weapons/axe/special/explosion/frame-16.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png",
          "/game/weapons/axe/special/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/axe/special/crater.map",
        "crater": "/game/weapons/axe/special/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/axe/special/crater-mask.png",
        "craterTimeline": {
          "width": 142,
          "height": 94,
          "anchor": {
            "x": 71,
            "y": 47
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/axe/special/border/frame-00.png",
              "bitmap_ids": [
                36
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 38,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 69,
          "height": 71,
          "anchor": {
            "x": 37,
            "y": 31
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/axe/special/projectile/frame-00.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 45,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 329,
          "height": 245,
          "anchor": {
            "x": 162,
            "y": 121
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/axe/special/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/axe/special/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/axe/special/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/axe/special/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/axe/special/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/axe/special/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/axe/special/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/axe/special/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/axe/special/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/axe/special/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/axe/special/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/axe/special/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/axe/special/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/axe/special/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/axe/special/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/axe/special/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [
                33
              ],
              "transparent": true
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/axe/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 35,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 21,
        "runtimeBallId": "21",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      }
    },
    {
      "id": "bow",
      "pic": "bow",
      "name": "硬弩弓",
      "templateId": "7002",
      "baseDamage": 175,
      "attack": 100,
      "defence": 24,
      "agility": 16,
      "luck": 10,
      "minAngle": 35,
      "maxAngle": 65,
      "icon": "/game/weapons/bow/icon.png",
      "held": "/game/weapons/bow/held.png",
      "heldSheet": "/game/weapons/bow/held-sheet.png",
      "heldAnchor": {
        "x": 62,
        "y": 83
      },
      "evidence": "Weapon family dated to 2009; original visuals and stats from later overseas archive; 2009 exact numerical/animation match pending",
      "angleEvidence": {
        "status": "Later archive candidate; exact 2009 angle range not confirmed"
      },
      "normal": {
        "power": 1.0,
        "radius": 50.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "bow-normal",
        "runtimeCraterId": "18",
        "projectile": [
          "/game/weapons/bow/normal/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-01.png",
          "/game/weapons/bow/normal/explosion/frame-02.png",
          "/game/weapons/bow/normal/explosion/frame-03.png",
          "/game/weapons/bow/normal/explosion/frame-04.png",
          "/game/weapons/bow/normal/explosion/frame-05.png",
          "/game/weapons/bow/normal/explosion/frame-06.png",
          "/game/weapons/bow/normal/explosion/frame-07.png",
          "/game/weapons/bow/normal/explosion/frame-08.png",
          "/game/weapons/bow/normal/explosion/frame-09.png",
          "/game/weapons/bow/normal/explosion/frame-10.png",
          "/game/weapons/bow/normal/explosion/frame-11.png",
          "/game/weapons/bow/normal/explosion/frame-12.png",
          "/game/weapons/bow/normal/explosion/frame-13.png",
          "/game/weapons/bow/normal/explosion/frame-14.png",
          "/game/weapons/bow/normal/explosion/frame-15.png",
          "/game/weapons/bow/normal/explosion/frame-16.png",
          "/game/weapons/bow/normal/explosion/frame-17.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png",
          "/game/weapons/bow/normal/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/bow/normal/crater.map",
        "crater": "/game/weapons/bow/normal/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/bow/normal/crater-mask.png",
        "craterTimeline": {
          "width": 120,
          "height": 80,
          "anchor": {
            "x": 60,
            "y": 40
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bow/normal/border/frame-00.png",
              "bitmap_ids": [
                36
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 38,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 62,
          "height": 30,
          "anchor": {
            "x": 41,
            "y": 14
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bow/normal/projectile/frame-00.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 45,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 324,
          "height": 244,
          "anchor": {
            "x": 162,
            "y": 122
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/bow/normal/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/bow/normal/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/bow/normal/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/bow/normal/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/bow/normal/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/bow/normal/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/bow/normal/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/bow/normal/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/bow/normal/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/bow/normal/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/bow/normal/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/bow/normal/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/bow/normal/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/bow/normal/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/bow/normal/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/bow/normal/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/bow/normal/explosion/frame-17.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/bow/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 35,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 18,
        "runtimeBallId": "18",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      },
      "special": {
        "power": 1.5,
        "radius": 59.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "bow-special",
        "runtimeCraterId": "18",
        "projectile": [
          "/game/weapons/bow/special/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-01.png",
          "/game/weapons/bow/special/explosion/frame-02.png",
          "/game/weapons/bow/special/explosion/frame-03.png",
          "/game/weapons/bow/special/explosion/frame-04.png",
          "/game/weapons/bow/special/explosion/frame-05.png",
          "/game/weapons/bow/special/explosion/frame-06.png",
          "/game/weapons/bow/special/explosion/frame-07.png",
          "/game/weapons/bow/special/explosion/frame-08.png",
          "/game/weapons/bow/special/explosion/frame-09.png",
          "/game/weapons/bow/special/explosion/frame-10.png",
          "/game/weapons/bow/special/explosion/frame-11.png",
          "/game/weapons/bow/special/explosion/frame-12.png",
          "/game/weapons/bow/special/explosion/frame-13.png",
          "/game/weapons/bow/special/explosion/frame-14.png",
          "/game/weapons/bow/special/explosion/frame-15.png",
          "/game/weapons/bow/special/explosion/frame-16.png",
          "/game/weapons/bow/special/explosion/frame-17.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png",
          "/game/weapons/bow/special/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/bow/special/crater.map",
        "crater": "/game/weapons/bow/special/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/bow/special/crater-mask.png",
        "craterTimeline": {
          "width": 140,
          "height": 94,
          "anchor": {
            "x": 70,
            "y": 47
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bow/special/border/frame-00.png",
              "bitmap_ids": [
                36
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 38,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 62,
          "height": 30,
          "anchor": {
            "x": 41,
            "y": 14
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bow/special/projectile/frame-00.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 45,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 324,
          "height": 244,
          "anchor": {
            "x": 162,
            "y": 122
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/bow/special/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/bow/special/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/bow/special/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/bow/special/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/bow/special/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/bow/special/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/bow/special/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/bow/special/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/bow/special/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/bow/special/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/bow/special/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/bow/special/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/bow/special/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/bow/special/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/bow/special/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/bow/special/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/bow/special/explosion/frame-17.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/bow/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 35,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 19,
        "runtimeBallId": "19",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      }
    },
    {
      "id": "gun",
      "pic": "gun",
      "name": "AK-48",
      "templateId": "7003",
      "baseDamage": 185,
      "attack": 100,
      "defence": 48,
      "agility": 18,
      "luck": 15,
      "minAngle": 35,
      "maxAngle": 60,
      "icon": "/game/weapons/gun/icon.png",
      "held": "/game/weapons/gun/held.png",
      "heldSheet": "/game/weapons/gun/held-sheet.png",
      "heldAnchor": {
        "x": 62,
        "y": 83
      },
      "evidence": "Weapon family dated to 2009; original visuals and stats from later overseas archive; 2009 exact numerical/animation match pending",
      "angleEvidence": {
        "status": "Later archive candidate; exact 2009 angle range not confirmed"
      },
      "normal": {
        "power": 1.0,
        "radius": 55.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "gun-normal",
        "runtimeCraterId": "22",
        "projectile": [
          "/game/weapons/gun/normal/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-01.png",
          "/game/weapons/gun/normal/explosion/frame-02.png",
          "/game/weapons/gun/normal/explosion/frame-03.png",
          "/game/weapons/gun/normal/explosion/frame-04.png",
          "/game/weapons/gun/normal/explosion/frame-05.png",
          "/game/weapons/gun/normal/explosion/frame-06.png",
          "/game/weapons/gun/normal/explosion/frame-07.png",
          "/game/weapons/gun/normal/explosion/frame-08.png",
          "/game/weapons/gun/normal/explosion/frame-09.png",
          "/game/weapons/gun/normal/explosion/frame-10.png",
          "/game/weapons/gun/normal/explosion/frame-11.png",
          "/game/weapons/gun/normal/explosion/frame-12.png",
          "/game/weapons/gun/normal/explosion/frame-13.png",
          "/game/weapons/gun/normal/explosion/frame-14.png",
          "/game/weapons/gun/normal/explosion/frame-15.png",
          "/game/weapons/gun/normal/explosion/frame-16.png",
          "/game/weapons/gun/normal/explosion/frame-17.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png",
          "/game/weapons/gun/normal/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/gun/normal/crater.map",
        "crater": "/game/weapons/gun/normal/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/gun/normal/crater-mask.png",
        "craterTimeline": {
          "width": 114,
          "height": 74,
          "anchor": {
            "x": 57,
            "y": 37
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/gun/normal/border/frame-00.png",
              "bitmap_ids": [
                36
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 38,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 39,
          "height": 31,
          "anchor": {
            "x": 27,
            "y": 15
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/gun/normal/projectile/frame-00.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 45,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 513,
          "height": 513,
          "anchor": {
            "x": 248,
            "y": 226
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/gun/normal/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/gun/normal/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/gun/normal/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/gun/normal/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/gun/normal/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/gun/normal/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/gun/normal/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/gun/normal/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/gun/normal/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/gun/normal/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/gun/normal/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/gun/normal/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/gun/normal/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/gun/normal/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/gun/normal/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/gun/normal/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/gun/normal/explosion/frame-17.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/gun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 35,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 22,
        "runtimeBallId": "22",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      },
      "special": {
        "power": 1.5,
        "radius": 65.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "gun-special",
        "runtimeCraterId": "23",
        "projectile": [
          "/game/weapons/gun/special/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-01.png",
          "/game/weapons/gun/special/explosion/frame-02.png",
          "/game/weapons/gun/special/explosion/frame-03.png",
          "/game/weapons/gun/special/explosion/frame-04.png",
          "/game/weapons/gun/special/explosion/frame-05.png",
          "/game/weapons/gun/special/explosion/frame-06.png",
          "/game/weapons/gun/special/explosion/frame-07.png",
          "/game/weapons/gun/special/explosion/frame-08.png",
          "/game/weapons/gun/special/explosion/frame-09.png",
          "/game/weapons/gun/special/explosion/frame-10.png",
          "/game/weapons/gun/special/explosion/frame-11.png",
          "/game/weapons/gun/special/explosion/frame-12.png",
          "/game/weapons/gun/special/explosion/frame-13.png",
          "/game/weapons/gun/special/explosion/frame-14.png",
          "/game/weapons/gun/special/explosion/frame-15.png",
          "/game/weapons/gun/special/explosion/frame-16.png",
          "/game/weapons/gun/special/explosion/frame-17.png",
          "/game/weapons/gun/special/explosion/frame-18.png",
          "/game/weapons/gun/special/explosion/frame-19.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png",
          "/game/weapons/gun/special/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/gun/special/crater.map",
        "crater": "/game/weapons/gun/special/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/gun/special/crater-mask.png",
        "craterTimeline": {
          "width": 132,
          "height": 84,
          "anchor": {
            "x": 66,
            "y": 42
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/gun/special/border/frame-00.png",
              "bitmap_ids": [
                40
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 42,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 93,
          "height": 56,
          "anchor": {
            "x": 67,
            "y": 28
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/gun/special/projectile/frame-00.png",
              "bitmap_ids": [
                47
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 49,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 513,
          "height": 513,
          "anchor": {
            "x": 237,
            "y": 212
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/gun/special/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/gun/special/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/gun/special/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/gun/special/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/gun/special/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/gun/special/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/gun/special/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/gun/special/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/gun/special/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/gun/special/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/gun/special/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/gun/special/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/gun/special/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/gun/special/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/gun/special/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/gun/special/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/gun/special/explosion/frame-17.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/gun/special/explosion/frame-18.png",
              "bitmap_ids": [
                35
              ],
              "transparent": false
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/gun/special/explosion/frame-19.png",
              "bitmap_ids": [
                37
              ],
              "transparent": false
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/gun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 39,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 23,
        "runtimeBallId": "23",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      }
    },
    {
      "id": "goldgun",
      "pic": "goldgun",
      "name": "上校的黄金枪",
      "templateId": "7005",
      "baseDamage": 185,
      "attack": 100,
      "defence": 55,
      "agility": 20,
      "luck": 15,
      "minAngle": 20,
      "maxAngle": 40,
      "icon": "/game/weapons/goldgun/icon.png",
      "held": "/game/weapons/goldgun/held.png",
      "heldSheet": "/game/weapons/goldgun/held-sheet.png",
      "heldAnchor": {
        "x": 62,
        "y": 83
      },
      "evidence": "Weapon family dated to 2009; original visuals and stats from later overseas archive; 2009 exact numerical/animation match pending",
      "angleEvidence": {
        "status": "Later archive candidate; exact 2009 angle range not confirmed"
      },
      "normal": {
        "power": 1.0,
        "radius": 55.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "goldgun-normal",
        "runtimeCraterId": "22",
        "projectile": [
          "/game/weapons/goldgun/normal/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-01.png",
          "/game/weapons/goldgun/normal/explosion/frame-02.png",
          "/game/weapons/goldgun/normal/explosion/frame-03.png",
          "/game/weapons/goldgun/normal/explosion/frame-04.png",
          "/game/weapons/goldgun/normal/explosion/frame-05.png",
          "/game/weapons/goldgun/normal/explosion/frame-06.png",
          "/game/weapons/goldgun/normal/explosion/frame-07.png",
          "/game/weapons/goldgun/normal/explosion/frame-08.png",
          "/game/weapons/goldgun/normal/explosion/frame-09.png",
          "/game/weapons/goldgun/normal/explosion/frame-10.png",
          "/game/weapons/goldgun/normal/explosion/frame-11.png",
          "/game/weapons/goldgun/normal/explosion/frame-12.png",
          "/game/weapons/goldgun/normal/explosion/frame-13.png",
          "/game/weapons/goldgun/normal/explosion/frame-14.png",
          "/game/weapons/goldgun/normal/explosion/frame-15.png",
          "/game/weapons/goldgun/normal/explosion/frame-16.png",
          "/game/weapons/goldgun/normal/explosion/frame-17.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png",
          "/game/weapons/goldgun/normal/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/goldgun/normal/crater.map",
        "crater": "/game/weapons/goldgun/normal/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/goldgun/normal/crater-mask.png",
        "craterTimeline": {
          "width": 114,
          "height": 74,
          "anchor": {
            "x": 57,
            "y": 37
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/goldgun/normal/border/frame-00.png",
              "bitmap_ids": [
                36
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 38,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 49,
          "height": 40,
          "anchor": {
            "x": 31,
            "y": 20
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/goldgun/normal/projectile/frame-00.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 45,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 513,
          "height": 513,
          "anchor": {
            "x": 253,
            "y": 216
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/goldgun/normal/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/goldgun/normal/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/goldgun/normal/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/goldgun/normal/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/goldgun/normal/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/goldgun/normal/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/goldgun/normal/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/goldgun/normal/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/goldgun/normal/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/goldgun/normal/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/goldgun/normal/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/goldgun/normal/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/goldgun/normal/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/goldgun/normal/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/goldgun/normal/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/goldgun/normal/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/goldgun/normal/explosion/frame-17.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/goldgun/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 35,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 30,
        "runtimeBallId": "30",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      },
      "special": {
        "power": 1.5,
        "radius": 65.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "goldgun-special",
        "runtimeCraterId": "23",
        "projectile": [
          "/game/weapons/goldgun/special/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-01.png",
          "/game/weapons/goldgun/special/explosion/frame-02.png",
          "/game/weapons/goldgun/special/explosion/frame-03.png",
          "/game/weapons/goldgun/special/explosion/frame-04.png",
          "/game/weapons/goldgun/special/explosion/frame-05.png",
          "/game/weapons/goldgun/special/explosion/frame-06.png",
          "/game/weapons/goldgun/special/explosion/frame-07.png",
          "/game/weapons/goldgun/special/explosion/frame-08.png",
          "/game/weapons/goldgun/special/explosion/frame-09.png",
          "/game/weapons/goldgun/special/explosion/frame-10.png",
          "/game/weapons/goldgun/special/explosion/frame-11.png",
          "/game/weapons/goldgun/special/explosion/frame-12.png",
          "/game/weapons/goldgun/special/explosion/frame-13.png",
          "/game/weapons/goldgun/special/explosion/frame-14.png",
          "/game/weapons/goldgun/special/explosion/frame-15.png",
          "/game/weapons/goldgun/special/explosion/frame-16.png",
          "/game/weapons/goldgun/special/explosion/frame-17.png",
          "/game/weapons/goldgun/special/explosion/frame-18.png",
          "/game/weapons/goldgun/special/explosion/frame-19.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png",
          "/game/weapons/goldgun/special/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/goldgun/special/crater.map",
        "crater": "/game/weapons/goldgun/special/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/goldgun/special/crater-mask.png",
        "craterTimeline": {
          "width": 132,
          "height": 84,
          "anchor": {
            "x": 66,
            "y": 42
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/goldgun/special/border/frame-00.png",
              "bitmap_ids": [
                40
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 42,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 91,
          "height": 55,
          "anchor": {
            "x": 66,
            "y": 27
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/goldgun/special/projectile/frame-00.png",
              "bitmap_ids": [
                47
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 49,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 513,
          "height": 513,
          "anchor": {
            "x": 255,
            "y": 210
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/goldgun/special/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/goldgun/special/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/goldgun/special/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/goldgun/special/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/goldgun/special/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/goldgun/special/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/goldgun/special/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/goldgun/special/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/goldgun/special/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/goldgun/special/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/goldgun/special/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/goldgun/special/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/goldgun/special/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/goldgun/special/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/goldgun/special/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/goldgun/special/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/goldgun/special/explosion/frame-17.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/goldgun/special/explosion/frame-18.png",
              "bitmap_ids": [
                35
              ],
              "transparent": false
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/goldgun/special/explosion/frame-19.png",
              "bitmap_ids": [
                37
              ],
              "transparent": false
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/goldgun/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 39,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 31,
        "runtimeBallId": "31",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      }
    },
    {
      "id": "axe3",
      "pic": "axe3",
      "name": "裂地金斧",
      "templateId": "7201",
      "baseDamage": 180,
      "attack": 18,
      "defence": 110,
      "agility": 13,
      "luck": 26,
      "minAngle": 35,
      "maxAngle": 65,
      "icon": "/game/weapons/axe3/icon.png",
      "held": "/game/weapons/axe3/held.png",
      "heldSheet": "/game/weapons/axe3/held-sheet.png",
      "heldAnchor": {
        "x": 62,
        "y": 83
      },
      "evidence": "Weapon family dated to 2009; original visuals and stats from later overseas archive; 2009 exact numerical/animation match pending",
      "angleEvidence": {
        "status": "Later archive candidate; exact 2009 angle range not confirmed"
      },
      "normal": {
        "power": 1.0,
        "radius": 55.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "axe3-normal",
        "runtimeCraterId": "20",
        "projectile": [
          "/game/weapons/axe3/normal/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-01.png",
          "/game/weapons/axe3/normal/explosion/frame-02.png",
          "/game/weapons/axe3/normal/explosion/frame-03.png",
          "/game/weapons/axe3/normal/explosion/frame-04.png",
          "/game/weapons/axe3/normal/explosion/frame-05.png",
          "/game/weapons/axe3/normal/explosion/frame-06.png",
          "/game/weapons/axe3/normal/explosion/frame-07.png",
          "/game/weapons/axe3/normal/explosion/frame-08.png",
          "/game/weapons/axe3/normal/explosion/frame-09.png",
          "/game/weapons/axe3/normal/explosion/frame-10.png",
          "/game/weapons/axe3/normal/explosion/frame-11.png",
          "/game/weapons/axe3/normal/explosion/frame-12.png",
          "/game/weapons/axe3/normal/explosion/frame-13.png",
          "/game/weapons/axe3/normal/explosion/frame-14.png",
          "/game/weapons/axe3/normal/explosion/frame-15.png",
          "/game/weapons/axe3/normal/explosion/frame-16.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png",
          "/game/weapons/axe3/normal/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/axe3/normal/crater.map",
        "crater": "/game/weapons/axe3/normal/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/axe3/normal/crater-mask.png",
        "craterTimeline": {
          "width": 122,
          "height": 78,
          "anchor": {
            "x": 61,
            "y": 39
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/axe3/normal/border/frame-00.png",
              "bitmap_ids": [
                36
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 38,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 52,
          "height": 52,
          "anchor": {
            "x": 32,
            "y": 32
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/axe3/normal/projectile/frame-00.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 45,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 329,
          "height": 245,
          "anchor": {
            "x": 162,
            "y": 121
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/axe3/normal/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/axe3/normal/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/axe3/normal/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/axe3/normal/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/axe3/normal/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/axe3/normal/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/axe3/normal/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/axe3/normal/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/axe3/normal/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/axe3/normal/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/axe3/normal/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/axe3/normal/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/axe3/normal/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/axe3/normal/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/axe3/normal/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/axe3/normal/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [
                33
              ],
              "transparent": true
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/axe3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 35,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 28,
        "runtimeBallId": "28",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      },
      "special": {
        "power": 1.5,
        "radius": 65.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "axe3-special",
        "runtimeCraterId": "20",
        "projectile": [
          "/game/weapons/axe3/special/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-01.png",
          "/game/weapons/axe3/special/explosion/frame-02.png",
          "/game/weapons/axe3/special/explosion/frame-03.png",
          "/game/weapons/axe3/special/explosion/frame-04.png",
          "/game/weapons/axe3/special/explosion/frame-05.png",
          "/game/weapons/axe3/special/explosion/frame-06.png",
          "/game/weapons/axe3/special/explosion/frame-07.png",
          "/game/weapons/axe3/special/explosion/frame-08.png",
          "/game/weapons/axe3/special/explosion/frame-09.png",
          "/game/weapons/axe3/special/explosion/frame-10.png",
          "/game/weapons/axe3/special/explosion/frame-11.png",
          "/game/weapons/axe3/special/explosion/frame-12.png",
          "/game/weapons/axe3/special/explosion/frame-13.png",
          "/game/weapons/axe3/special/explosion/frame-14.png",
          "/game/weapons/axe3/special/explosion/frame-15.png",
          "/game/weapons/axe3/special/explosion/frame-16.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png",
          "/game/weapons/axe3/special/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/axe3/special/crater.map",
        "crater": "/game/weapons/axe3/special/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/axe3/special/crater-mask.png",
        "craterTimeline": {
          "width": 142,
          "height": 94,
          "anchor": {
            "x": 71,
            "y": 47
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/axe3/special/border/frame-00.png",
              "bitmap_ids": [
                36
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 38,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 75,
          "height": 74,
          "anchor": {
            "x": 43,
            "y": 33
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/axe3/special/projectile/frame-00.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 45,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 329,
          "height": 245,
          "anchor": {
            "x": 162,
            "y": 121
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/axe3/special/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/axe3/special/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/axe3/special/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/axe3/special/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/axe3/special/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/axe3/special/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/axe3/special/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/axe3/special/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/axe3/special/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/axe3/special/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/axe3/special/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/axe3/special/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/axe3/special/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/axe3/special/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/axe3/special/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/axe3/special/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [
                33
              ],
              "transparent": true
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/axe3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 35,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 29,
        "runtimeBallId": "29",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      }
    },
    {
      "id": "bow3",
      "pic": "bow3",
      "name": "击天金弓",
      "templateId": "7202",
      "baseDamage": 180,
      "attack": 115,
      "defence": 25,
      "agility": 18,
      "luck": 10,
      "minAngle": 35,
      "maxAngle": 65,
      "icon": "/game/weapons/bow3/icon.png",
      "held": "/game/weapons/bow3/held.png",
      "heldSheet": "/game/weapons/bow3/held-sheet.png",
      "heldAnchor": {
        "x": 62,
        "y": 83
      },
      "evidence": "Weapon family dated to 2009; original visuals and stats from later overseas archive; 2009 exact numerical/animation match pending",
      "angleEvidence": {
        "status": "Later archive candidate; exact 2009 angle range not confirmed"
      },
      "normal": {
        "power": 1.0,
        "radius": 50.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "bow3-normal",
        "runtimeCraterId": "18",
        "projectile": [
          "/game/weapons/bow3/normal/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-01.png",
          "/game/weapons/bow3/normal/explosion/frame-02.png",
          "/game/weapons/bow3/normal/explosion/frame-03.png",
          "/game/weapons/bow3/normal/explosion/frame-04.png",
          "/game/weapons/bow3/normal/explosion/frame-05.png",
          "/game/weapons/bow3/normal/explosion/frame-06.png",
          "/game/weapons/bow3/normal/explosion/frame-07.png",
          "/game/weapons/bow3/normal/explosion/frame-08.png",
          "/game/weapons/bow3/normal/explosion/frame-09.png",
          "/game/weapons/bow3/normal/explosion/frame-10.png",
          "/game/weapons/bow3/normal/explosion/frame-11.png",
          "/game/weapons/bow3/normal/explosion/frame-12.png",
          "/game/weapons/bow3/normal/explosion/frame-13.png",
          "/game/weapons/bow3/normal/explosion/frame-14.png",
          "/game/weapons/bow3/normal/explosion/frame-15.png",
          "/game/weapons/bow3/normal/explosion/frame-16.png",
          "/game/weapons/bow3/normal/explosion/frame-17.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png",
          "/game/weapons/bow3/normal/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/bow3/normal/crater.map",
        "crater": "/game/weapons/bow3/normal/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/bow3/normal/crater-mask.png",
        "craterTimeline": {
          "width": 120,
          "height": 80,
          "anchor": {
            "x": 60,
            "y": 40
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bow3/normal/border/frame-00.png",
              "bitmap_ids": [
                36
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 38,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 61,
          "height": 30,
          "anchor": {
            "x": 41,
            "y": 14
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bow3/normal/projectile/frame-00.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 45,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 324,
          "height": 244,
          "anchor": {
            "x": 162,
            "y": 122
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/bow3/normal/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/bow3/normal/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/bow3/normal/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/bow3/normal/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/bow3/normal/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/bow3/normal/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/bow3/normal/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/bow3/normal/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/bow3/normal/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/bow3/normal/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/bow3/normal/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/bow3/normal/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/bow3/normal/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/bow3/normal/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/bow3/normal/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/bow3/normal/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/bow3/normal/explosion/frame-17.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/bow3/normal/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 35,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 42,
        "runtimeBallId": "42",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      },
      "special": {
        "power": 1.5,
        "radius": 59.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0,
        "amount": 1,
        "spin": 0,
        "craterId": "bow3-special",
        "runtimeCraterId": "18",
        "projectile": [
          "/game/weapons/bow3/special/projectile/frame-00.png"
        ],
        "explosion": [
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-01.png",
          "/game/weapons/bow3/special/explosion/frame-02.png",
          "/game/weapons/bow3/special/explosion/frame-03.png",
          "/game/weapons/bow3/special/explosion/frame-04.png",
          "/game/weapons/bow3/special/explosion/frame-05.png",
          "/game/weapons/bow3/special/explosion/frame-06.png",
          "/game/weapons/bow3/special/explosion/frame-07.png",
          "/game/weapons/bow3/special/explosion/frame-08.png",
          "/game/weapons/bow3/special/explosion/frame-09.png",
          "/game/weapons/bow3/special/explosion/frame-10.png",
          "/game/weapons/bow3/special/explosion/frame-11.png",
          "/game/weapons/bow3/special/explosion/frame-12.png",
          "/game/weapons/bow3/special/explosion/frame-13.png",
          "/game/weapons/bow3/special/explosion/frame-14.png",
          "/game/weapons/bow3/special/explosion/frame-15.png",
          "/game/weapons/bow3/special/explosion/frame-16.png",
          "/game/weapons/bow3/special/explosion/frame-17.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png",
          "/game/weapons/bow3/special/explosion/frame-00.png"
        ],
        "craterMask": "/game/weapons/bow3/special/crater.map",
        "crater": "/game/weapons/bow3/special/border/frame-00.png",
        "craterDebugTexture": "/game/weapons/bow3/special/crater-mask.png",
        "craterTimeline": {
          "width": 140,
          "height": 94,
          "anchor": {
            "x": 70,
            "y": 47
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bow3/special/border/frame-00.png",
              "bitmap_ids": [
                36
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 38,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "projectileTimeline": {
          "width": 61,
          "height": 30,
          "anchor": {
            "x": 41,
            "y": 14
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bow3/special/projectile/frame-00.png",
              "bitmap_ids": [
                43
              ],
              "transparent": false
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 45,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "explosionTimeline": {
          "width": 324,
          "height": 244,
          "anchor": {
            "x": 162,
            "y": 122
          },
          "frames": [
            {
              "source_frame": 1,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 2,
              "url": "/game/weapons/bow3/special/explosion/frame-01.png",
              "bitmap_ids": [
                1
              ],
              "transparent": false
            },
            {
              "source_frame": 3,
              "url": "/game/weapons/bow3/special/explosion/frame-02.png",
              "bitmap_ids": [
                3
              ],
              "transparent": false
            },
            {
              "source_frame": 4,
              "url": "/game/weapons/bow3/special/explosion/frame-03.png",
              "bitmap_ids": [
                5
              ],
              "transparent": false
            },
            {
              "source_frame": 5,
              "url": "/game/weapons/bow3/special/explosion/frame-04.png",
              "bitmap_ids": [
                7
              ],
              "transparent": false
            },
            {
              "source_frame": 6,
              "url": "/game/weapons/bow3/special/explosion/frame-05.png",
              "bitmap_ids": [
                9
              ],
              "transparent": false
            },
            {
              "source_frame": 7,
              "url": "/game/weapons/bow3/special/explosion/frame-06.png",
              "bitmap_ids": [
                11
              ],
              "transparent": false
            },
            {
              "source_frame": 8,
              "url": "/game/weapons/bow3/special/explosion/frame-07.png",
              "bitmap_ids": [
                13
              ],
              "transparent": false
            },
            {
              "source_frame": 9,
              "url": "/game/weapons/bow3/special/explosion/frame-08.png",
              "bitmap_ids": [
                15
              ],
              "transparent": false
            },
            {
              "source_frame": 10,
              "url": "/game/weapons/bow3/special/explosion/frame-09.png",
              "bitmap_ids": [
                17
              ],
              "transparent": false
            },
            {
              "source_frame": 11,
              "url": "/game/weapons/bow3/special/explosion/frame-10.png",
              "bitmap_ids": [
                19
              ],
              "transparent": false
            },
            {
              "source_frame": 12,
              "url": "/game/weapons/bow3/special/explosion/frame-11.png",
              "bitmap_ids": [
                21
              ],
              "transparent": false
            },
            {
              "source_frame": 13,
              "url": "/game/weapons/bow3/special/explosion/frame-12.png",
              "bitmap_ids": [
                23
              ],
              "transparent": false
            },
            {
              "source_frame": 14,
              "url": "/game/weapons/bow3/special/explosion/frame-13.png",
              "bitmap_ids": [
                25
              ],
              "transparent": false
            },
            {
              "source_frame": 15,
              "url": "/game/weapons/bow3/special/explosion/frame-14.png",
              "bitmap_ids": [
                27
              ],
              "transparent": false
            },
            {
              "source_frame": 16,
              "url": "/game/weapons/bow3/special/explosion/frame-15.png",
              "bitmap_ids": [
                29
              ],
              "transparent": false
            },
            {
              "source_frame": 17,
              "url": "/game/weapons/bow3/special/explosion/frame-16.png",
              "bitmap_ids": [
                31
              ],
              "transparent": false
            },
            {
              "source_frame": 18,
              "url": "/game/weapons/bow3/special/explosion/frame-17.png",
              "bitmap_ids": [
                33
              ],
              "transparent": false
            },
            {
              "source_frame": 19,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 20,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 21,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 22,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 23,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 24,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 25,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 26,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 27,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 28,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 29,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 30,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 31,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 32,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 33,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 34,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 35,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 36,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 37,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 38,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 39,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 40,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 41,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 42,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 43,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 44,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 45,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 46,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 47,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 48,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 49,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 50,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            },
            {
              "source_frame": 51,
              "url": "/game/weapons/bow3/special/explosion/frame-00.png",
              "bitmap_ids": [],
              "transparent": true
            }
          ],
          "frameRate": 25,
          "loop": false,
          "source_character_id": 35,
          "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
        },
        "legacyVisualId": 43,
        "runtimeBallId": "43",
        "visualEvidence": "Legacy package ball frame 1 selects base form; enhanced selection frames deliberately excluded. Boon follows static original display-list order.",
        "parameterEvidence": "Matched later Gunny 3.0 BallList/BombConfig candidate, not claimed as verified 2009 constants"
      }
    }
  ],
  "characters": [
    {
      "id": "m",
      "name": "默认男角色",
      "idle": [
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-06-upper-06.png",
        "/game/characters/m/idle/face-06-upper-06.png",
        "/game/characters/m/idle/face-07-upper-07.png",
        "/game/characters/m/idle/face-07-upper-07.png",
        "/game/characters/m/idle/face-08-upper-08.png",
        "/game/characters/m/idle/face-08-upper-08.png",
        "/game/characters/m/idle/face-09-upper-09.png",
        "/game/characters/m/idle/face-09-upper-09.png",
        "/game/characters/m/idle/face-09-upper-09.png",
        "/game/characters/m/idle/face-09-upper-09.png",
        "/game/characters/m/idle/face-08-upper-08.png",
        "/game/characters/m/idle/face-08-upper-08.png",
        "/game/characters/m/idle/face-07-upper-07.png",
        "/game/characters/m/idle/face-07-upper-07.png",
        "/game/characters/m/idle/face-06-upper-06.png",
        "/game/characters/m/idle/face-06-upper-06.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-10-upper-07.png",
        "/game/characters/m/idle/face-10-upper-07.png",
        "/game/characters/m/idle/face-10-upper-07.png",
        "/game/characters/m/idle/face-10-upper-07.png",
        "/game/characters/m/idle/face-10-upper-07.png",
        "/game/characters/m/idle/face-10-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-00-upper-07.png",
        "/game/characters/m/idle/face-10-upper-07.png",
        "/game/characters/m/idle/face-10-upper-07.png",
        "/game/characters/m/idle/face-10-upper-07.png",
        "/game/characters/m/idle/face-10-upper-07.png",
        "/game/characters/m/idle/face-10-upper-07.png",
        "/game/characters/m/idle/face-10-upper-07.png"
      ],
      "walk": [
        "/game/characters/m/frame-01.png",
        "/game/characters/m/frame-01.png",
        "/game/characters/m/frame-02.png",
        "/game/characters/m/frame-02.png",
        "/game/characters/m/frame-03.png",
        "/game/characters/m/frame-03.png",
        "/game/characters/m/frame-04.png",
        "/game/characters/m/frame-04.png",
        "/game/characters/m/frame-05.png",
        "/game/characters/m/frame-05.png"
      ],
      "shot": [
        "/game/characters/m/frame-22.png",
        "/game/characters/m/frame-23.png",
        "/game/characters/m/frame-26.png",
        "/game/characters/m/frame-27.png"
      ],
      "throw": [
        "/game/characters/m/frame-31.png",
        "/game/characters/m/frame-32.png",
        "/game/characters/m/frame-33.png",
        "/game/characters/m/frame-34.png",
        "/game/characters/m/frame-35.png"
      ],
      "showgun": [
        "/game/characters/m/frame-19.png",
        "/game/characters/m/frame-20.png",
        "/game/characters/m/frame-21.png",
        "/game/characters/m/frame-21.png",
        "/game/characters/m/frame-21.png"
      ],
      "showthrows": [
        "/game/characters/m/frame-28.png",
        "/game/characters/m/frame-29.png",
        "/game/characters/m/frame-30.png",
        "/game/characters/m/frame-30.png",
        "/game/characters/m/frame-30.png"
      ],
      "width": 114,
      "height": 95,
      "anchor": {
        "x": 62,
        "y": 83
      },
      "weaponAnchor": {
        "x": 62,
        "y": 83
      },
      "sheet": "/game/characters/m/sheet.png",
      "sheetColumns": 13,
      "sheetRows": 3,
      "frameRate": 25,
      "animationTimelines": {
        "walk": {
          "frameRate": 25,
          "sourceFrames": [
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5
          ],
          "faceSourceFrames": [
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5
          ],
          "upperSourceFrames": [
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5
          ]
        },
        "shot": {
          "frameRate": 25,
          "sourceFrames": [
            22,
            23,
            26,
            27
          ],
          "faceSourceFrames": [
            22,
            23,
            26,
            27
          ],
          "upperSourceFrames": [
            22,
            23,
            26,
            27
          ]
        },
        "throw": {
          "frameRate": 25,
          "sourceFrames": [
            31,
            32,
            33,
            34,
            35
          ],
          "faceSourceFrames": [
            31,
            32,
            33,
            34,
            35
          ],
          "upperSourceFrames": [
            31,
            32,
            33,
            34,
            35
          ]
        },
        "showgun": {
          "frameRate": 25,
          "sourceFrames": [
            19,
            20,
            21,
            21,
            21
          ],
          "faceSourceFrames": [
            19,
            20,
            21,
            21,
            21
          ],
          "upperSourceFrames": [
            19,
            20,
            21,
            21,
            21
          ]
        },
        "showthrows": {
          "frameRate": 25,
          "sourceFrames": [
            28,
            29,
            30,
            30,
            30
          ],
          "faceSourceFrames": [
            28,
            29,
            30,
            30,
            30
          ],
          "upperSourceFrames": [
            28,
            29,
            30,
            30,
            30
          ]
        },
        "idle": {
          "frameRate": 25,
          "sourceFrames": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            9,
            9,
            8,
            8,
            7,
            7,
            6,
            6,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10,
            10,
            10,
            10,
            10,
            10,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10,
            10,
            10,
            10,
            10,
            10
          ],
          "faceSourceFrames": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            9,
            9,
            8,
            8,
            7,
            7,
            6,
            6,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10,
            10,
            10,
            10,
            10,
            10,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10,
            10,
            10,
            10,
            10,
            10
          ],
          "upperSourceFrames": [
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            9,
            9,
            8,
            8,
            7,
            7,
            6,
            6,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7
          ]
        }
      },
      "roomPortrait": "/game/characters/m/roomPortrait.png",
      "roomPortraitFull": "/game/characters/m/roomPortrait-full.png",
      "roomPortraitWidth": 155,
      "roomPortraitHeight": 233,
      "roomPortraitBounds": [
        19,
        74,
        174,
        307
      ],
      "roomPortraitCanvas": {
        "width": 250,
        "height": 342
      },
      "layerGroups": {
        "face": [
          "face"
        ],
        "faceUp": [
          "hair",
          "cloth",
          "eff",
          "head",
          "glass"
        ],
        "faceDown": [
          "weapon"
        ],
        "weaponRenderedSeparately": true
      },
      "evidence": "Pinned original GameCharacter layer grouping and per-action source frames; original default Gunny3.0 character/room textures. Exact2009 costume/date unverified. Small crouched battle body is preserved from source; no stretched body or invented standing pose."
    },
    {
      "id": "f",
      "name": "默认女角色",
      "idle": [
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-06-upper-06.png",
        "/game/characters/f/idle/face-06-upper-06.png",
        "/game/characters/f/idle/face-07-upper-07.png",
        "/game/characters/f/idle/face-07-upper-07.png",
        "/game/characters/f/idle/face-08-upper-08.png",
        "/game/characters/f/idle/face-08-upper-08.png",
        "/game/characters/f/idle/face-09-upper-09.png",
        "/game/characters/f/idle/face-09-upper-09.png",
        "/game/characters/f/idle/face-09-upper-09.png",
        "/game/characters/f/idle/face-09-upper-09.png",
        "/game/characters/f/idle/face-08-upper-08.png",
        "/game/characters/f/idle/face-08-upper-08.png",
        "/game/characters/f/idle/face-07-upper-07.png",
        "/game/characters/f/idle/face-07-upper-07.png",
        "/game/characters/f/idle/face-06-upper-06.png",
        "/game/characters/f/idle/face-06-upper-06.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-10-upper-07.png",
        "/game/characters/f/idle/face-10-upper-07.png",
        "/game/characters/f/idle/face-10-upper-07.png",
        "/game/characters/f/idle/face-10-upper-07.png",
        "/game/characters/f/idle/face-10-upper-07.png",
        "/game/characters/f/idle/face-10-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-00-upper-07.png",
        "/game/characters/f/idle/face-10-upper-07.png",
        "/game/characters/f/idle/face-10-upper-07.png",
        "/game/characters/f/idle/face-10-upper-07.png",
        "/game/characters/f/idle/face-10-upper-07.png",
        "/game/characters/f/idle/face-10-upper-07.png",
        "/game/characters/f/idle/face-10-upper-07.png"
      ],
      "walk": [
        "/game/characters/f/frame-01.png",
        "/game/characters/f/frame-01.png",
        "/game/characters/f/frame-02.png",
        "/game/characters/f/frame-02.png",
        "/game/characters/f/frame-03.png",
        "/game/characters/f/frame-03.png",
        "/game/characters/f/frame-04.png",
        "/game/characters/f/frame-04.png",
        "/game/characters/f/frame-05.png",
        "/game/characters/f/frame-05.png"
      ],
      "shot": [
        "/game/characters/f/frame-22.png",
        "/game/characters/f/frame-23.png",
        "/game/characters/f/frame-26.png",
        "/game/characters/f/frame-27.png"
      ],
      "throw": [
        "/game/characters/f/frame-31.png",
        "/game/characters/f/frame-32.png",
        "/game/characters/f/frame-33.png",
        "/game/characters/f/frame-34.png",
        "/game/characters/f/frame-35.png"
      ],
      "showgun": [
        "/game/characters/f/frame-19.png",
        "/game/characters/f/frame-20.png",
        "/game/characters/f/frame-21.png",
        "/game/characters/f/frame-21.png",
        "/game/characters/f/frame-21.png"
      ],
      "showthrows": [
        "/game/characters/f/frame-28.png",
        "/game/characters/f/frame-29.png",
        "/game/characters/f/frame-30.png",
        "/game/characters/f/frame-30.png",
        "/game/characters/f/frame-30.png"
      ],
      "width": 114,
      "height": 95,
      "anchor": {
        "x": 62,
        "y": 83
      },
      "weaponAnchor": {
        "x": 62,
        "y": 83
      },
      "sheet": "/game/characters/f/sheet.png",
      "sheetColumns": 13,
      "sheetRows": 3,
      "frameRate": 25,
      "animationTimelines": {
        "walk": {
          "frameRate": 25,
          "sourceFrames": [
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5
          ],
          "faceSourceFrames": [
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5
          ],
          "upperSourceFrames": [
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5
          ]
        },
        "shot": {
          "frameRate": 25,
          "sourceFrames": [
            22,
            23,
            26,
            27
          ],
          "faceSourceFrames": [
            22,
            23,
            26,
            27
          ],
          "upperSourceFrames": [
            22,
            23,
            26,
            27
          ]
        },
        "throw": {
          "frameRate": 25,
          "sourceFrames": [
            31,
            32,
            33,
            34,
            35
          ],
          "faceSourceFrames": [
            31,
            32,
            33,
            34,
            35
          ],
          "upperSourceFrames": [
            31,
            32,
            33,
            34,
            35
          ]
        },
        "showgun": {
          "frameRate": 25,
          "sourceFrames": [
            19,
            20,
            21,
            21,
            21
          ],
          "faceSourceFrames": [
            19,
            20,
            21,
            21,
            21
          ],
          "upperSourceFrames": [
            19,
            20,
            21,
            21,
            21
          ]
        },
        "showthrows": {
          "frameRate": 25,
          "sourceFrames": [
            28,
            29,
            30,
            30,
            30
          ],
          "faceSourceFrames": [
            28,
            29,
            30,
            30,
            30
          ],
          "upperSourceFrames": [
            28,
            29,
            30,
            30,
            30
          ]
        },
        "idle": {
          "frameRate": 25,
          "sourceFrames": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            9,
            9,
            8,
            8,
            7,
            7,
            6,
            6,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10,
            10,
            10,
            10,
            10,
            10,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10,
            10,
            10,
            10,
            10,
            10
          ],
          "faceSourceFrames": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            9,
            9,
            8,
            8,
            7,
            7,
            6,
            6,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10,
            10,
            10,
            10,
            10,
            10,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10,
            10,
            10,
            10,
            10,
            10
          ],
          "upperSourceFrames": [
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            9,
            9,
            8,
            8,
            7,
            7,
            6,
            6,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7
          ]
        }
      },
      "roomPortrait": "/game/characters/f/roomPortrait.png",
      "roomPortraitFull": "/game/characters/f/roomPortrait-full.png",
      "roomPortraitWidth": 155,
      "roomPortraitHeight": 233,
      "roomPortraitBounds": [
        19,
        74,
        174,
        307
      ],
      "roomPortraitCanvas": {
        "width": 250,
        "height": 342
      },
      "layerGroups": {
        "face": [
          "face"
        ],
        "faceUp": [
          "hair",
          "cloth",
          "eff",
          "head",
          "glass"
        ],
        "faceDown": [
          "weapon"
        ],
        "weaponRenderedSeparately": true
      },
      "evidence": "Pinned original GameCharacter layer grouping and per-action source frames; original default Gunny3.0 character/room textures. Exact2009 costume/date unverified. Small crouched battle body is preserved from source; no stretched body or invented standing pose."
    }
  ],
  "sounds": {
    "shoot": "/game/audio/Sound025.mp3",
    "explode": "/game/audio/Sound087.mp3",
    "background": "/game/audio/background-1001.mp3"
  },
  "audio": {
    "shoot": "/game/audio/Sound025.mp3",
    "explode": "/game/audio/Sound087.mp3",
    "background": "/game/audio/background-1001.mp3"
  },
  "ui": {
    "powIcon": "/game/ui/props/pow.png",
    "powerBack": "/game/ui/hud/powerBack.png",
    "angleBack": "/game/ui/hud/angleBack.png",
    "angleDial": "/game/ui/hud/angleDial.png",
    "angleHalfRound": "/game/ui/hud/angleHalfRound.png",
    "powerStrip": "/game/ui/hud/powerStrip.png",
    "propBack": "/game/ui/hud/propBack.png",
    "propCell": "/game/ui/hud/propCell.png",
    "propCellFore": "/game/ui/hud/propCellFore.png",
    "energyBack": "/game/ui/hud/energyBack.png",
    "healthBack": "/game/ui/hud/healthBack.png",
    "danderBack": "/game/ui/hud/danderBack.png",
    "danderBg": "/game/ui/hud/danderBg.png",
    "danderAnimationBack": "/game/ui/hud/danderAnimationBack.png",
    "weaponBack": "/game/ui/hud/weaponBack.png",
    "smallHpBack": "/game/ui/hud/smallHpBack.png",
    "smallHpRed": "/game/ui/hud/smallHpRed.png",
    "smallHpBlue": "/game/ui/hud/smallHpBlue.png",
    "evidence": "Original later overseas battle HUD candidates; dated 2009 layout remains the design reference"
  },
  "props": [
    {
      "id": "damage10",
      "name": "伤害+10%",
      "icon": "/game/ui/props/damage10.png",
      "symbol": "game.crazyTank.view.Prop13Asset",
      "evidence": "Original later overseas UI resource; prop identity from matching template Pic mapping, 2009 design chronology pending"
    },
    {
      "id": "damage20",
      "name": "伤害+20%",
      "icon": "/game/ui/props/damage20.png",
      "symbol": "game.crazyTank.view.Prop14Asset",
      "evidence": "Original later overseas UI resource; prop identity from matching template Pic mapping, 2009 design chronology pending"
    },
    {
      "id": "damage30",
      "name": "伤害+30%",
      "icon": "/game/ui/props/damage30.png",
      "symbol": "game.crazyTank.view.Prop15Asset",
      "evidence": "Original later overseas UI resource; prop identity from matching template Pic mapping, 2009 design chronology pending"
    },
    {
      "id": "damage40",
      "name": "伤害+40%",
      "icon": "/game/ui/props/damage40.png",
      "symbol": "game.crazyTank.view.Prop16Asset",
      "evidence": "Original later overseas UI resource; prop identity from matching template Pic mapping, 2009 design chronology pending"
    },
    {
      "id": "damage50",
      "name": "伤害+50%",
      "icon": "/game/ui/props/damage50.png",
      "symbol": "game.crazyTank.view.Prop17Asset",
      "evidence": "Original later overseas UI resource; prop identity from matching template Pic mapping, 2009 design chronology pending"
    },
    {
      "id": "extra1",
      "name": "附加1次攻击",
      "icon": "/game/ui/props/extra1.png",
      "symbol": "game.crazyTank.view.Prop18Asset",
      "evidence": "Original later overseas UI resource; prop identity from matching template Pic mapping, 2009 design chronology pending"
    },
    {
      "id": "extra2",
      "name": "附加2次攻击",
      "icon": "/game/ui/props/extra2.png",
      "symbol": "game.crazyTank.view.Prop19Asset",
      "evidence": "Original later overseas UI resource; prop identity from matching template Pic mapping, 2009 design chronology pending"
    },
    {
      "id": "trident",
      "name": "三叉戟",
      "icon": "/game/ui/props/trident.png",
      "symbol": "game.crazyTank.view.Prop20Asset",
      "evidence": "Original later overseas UI resource; prop identity from matching template Pic mapping, 2009 design chronology pending"
    },
    {
      "id": "fly",
      "name": "飞行",
      "icon": "/game/ui/props/fly.png",
      "symbol": "game.crazyTank.view.Prop2Asset",
      "evidence": "Original later overseas UI resource; prop identity from matching template Pic mapping, 2009 design chronology pending"
    },
    {
      "id": "ice",
      "name": "冰冻弹",
      "icon": "/game/ui/props/ice.png",
      "symbol": "game.crazyTank.view.Prop4Asset",
      "evidence": "Original later overseas UI resource; prop identity from matching template Pic mapping, 2009 design chronology pending"
    }
  ],
  "actions": {
    "fly": {
      "id": "fly",
      "name": "纸飞机",
      "ballId": 3,
      "projectile": [
        "/game/actions/fly/projectile/frame-00.png",
        "/game/actions/fly/projectile/frame-00.png",
        "/game/actions/fly/projectile/frame-02.png",
        "/game/actions/fly/projectile/frame-02.png"
      ],
      "explosion": [
        "/game/actions/fly/explosion/frame-00.png",
        "/game/actions/fly/explosion/frame-01.png",
        "/game/actions/fly/explosion/frame-02.png",
        "/game/actions/fly/explosion/frame-03.png",
        "/game/actions/fly/explosion/frame-04.png",
        "/game/actions/fly/explosion/frame-04.png",
        "/game/actions/fly/explosion/frame-06.png",
        "/game/actions/fly/explosion/frame-06.png",
        "/game/actions/fly/explosion/frame-08.png",
        "/game/actions/fly/explosion/frame-08.png",
        "/game/actions/fly/explosion/frame-10.png",
        "/game/actions/fly/explosion/frame-10.png",
        "/game/actions/fly/explosion/frame-12.png",
        "/game/actions/fly/explosion/frame-13.png",
        "/game/actions/fly/explosion/frame-00.png"
      ],
      "projectileTimeline": {
        "width": 67,
        "height": 53,
        "anchor": {
          "x": 48,
          "y": 27
        },
        "frames": [
          {
            "source_frame": 1,
            "url": "/game/actions/fly/projectile/frame-00.png",
            "bitmap_ids": [
              129
            ],
            "transparent": false
          },
          {
            "source_frame": 2,
            "url": "/game/actions/fly/projectile/frame-00.png",
            "bitmap_ids": [
              129
            ],
            "transparent": false
          },
          {
            "source_frame": 3,
            "url": "/game/actions/fly/projectile/frame-02.png",
            "bitmap_ids": [
              129,
              131
            ],
            "transparent": false
          },
          {
            "source_frame": 4,
            "url": "/game/actions/fly/projectile/frame-02.png",
            "bitmap_ids": [
              129,
              131
            ],
            "transparent": false
          }
        ],
        "frameRate": 25,
        "loop": true,
        "source_character_id": 133,
        "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed",
        "loopEvidence": "Anonymous nested DefineSprite advances and loops its four original frames; explosion has a separate finite timeline"
      },
      "explosionTimeline": {
        "width": 324,
        "height": 183,
        "anchor": {
          "x": 166,
          "y": 151
        },
        "frames": [
          {
            "source_frame": 1,
            "url": "/game/actions/fly/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 2,
            "url": "/game/actions/fly/explosion/frame-01.png",
            "bitmap_ids": [
              101
            ],
            "transparent": false
          },
          {
            "source_frame": 3,
            "url": "/game/actions/fly/explosion/frame-02.png",
            "bitmap_ids": [
              103
            ],
            "transparent": false
          },
          {
            "source_frame": 4,
            "url": "/game/actions/fly/explosion/frame-03.png",
            "bitmap_ids": [
              105
            ],
            "transparent": false
          },
          {
            "source_frame": 5,
            "url": "/game/actions/fly/explosion/frame-04.png",
            "bitmap_ids": [
              107
            ],
            "transparent": false
          },
          {
            "source_frame": 6,
            "url": "/game/actions/fly/explosion/frame-04.png",
            "bitmap_ids": [
              109
            ],
            "transparent": false
          },
          {
            "source_frame": 7,
            "url": "/game/actions/fly/explosion/frame-06.png",
            "bitmap_ids": [
              111
            ],
            "transparent": false
          },
          {
            "source_frame": 8,
            "url": "/game/actions/fly/explosion/frame-06.png",
            "bitmap_ids": [
              113
            ],
            "transparent": false
          },
          {
            "source_frame": 9,
            "url": "/game/actions/fly/explosion/frame-08.png",
            "bitmap_ids": [
              115
            ],
            "transparent": false
          },
          {
            "source_frame": 10,
            "url": "/game/actions/fly/explosion/frame-08.png",
            "bitmap_ids": [
              117
            ],
            "transparent": false
          },
          {
            "source_frame": 11,
            "url": "/game/actions/fly/explosion/frame-10.png",
            "bitmap_ids": [
              119
            ],
            "transparent": false
          },
          {
            "source_frame": 12,
            "url": "/game/actions/fly/explosion/frame-10.png",
            "bitmap_ids": [
              121
            ],
            "transparent": false
          },
          {
            "source_frame": 13,
            "url": "/game/actions/fly/explosion/frame-12.png",
            "bitmap_ids": [
              123
            ],
            "transparent": false
          },
          {
            "source_frame": 14,
            "url": "/game/actions/fly/explosion/frame-13.png",
            "bitmap_ids": [
              126
            ],
            "transparent": false
          },
          {
            "source_frame": 15,
            "url": "/game/actions/fly/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          }
        ],
        "frameRate": 25,
        "loop": false,
        "source_character_id": 128,
        "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
      },
      "rotationOffset": 0,
      "orientationEvidence": "Original paper-plane nose points right in its local coordinates; orient by atan2 flight heading using the original anchor",
      "candidatePhysics": {
        "power": 0.0,
        "radius": 60.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0
      },
      "craterId": null,
      "flyingPartical": "",
      "visualEvidence": "Exact original SymbolClass tank.resource.bombs.Bomb3 in composite bombs/1.swf; local ball and boon display lists reconstructed statically. Later original candidate, 2009 exact animation chronology unconfirmed.",
      "parameterEvidence": "Matching later DDTank-II BallList candidate; ActionType=0 is shared by both actions and does not identify the action. FlyingPartical is only a trail reference."
    },
    "ice": {
      "id": "ice",
      "name": "冰冻弹",
      "ballId": 1,
      "projectile": [
        "/game/actions/ice/projectile/frame-00.png"
      ],
      "explosion": [
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-01.png",
        "/game/actions/ice/explosion/frame-02.png",
        "/game/actions/ice/explosion/frame-03.png",
        "/game/actions/ice/explosion/frame-04.png",
        "/game/actions/ice/explosion/frame-05.png",
        "/game/actions/ice/explosion/frame-06.png",
        "/game/actions/ice/explosion/frame-07.png",
        "/game/actions/ice/explosion/frame-08.png",
        "/game/actions/ice/explosion/frame-09.png",
        "/game/actions/ice/explosion/frame-10.png",
        "/game/actions/ice/explosion/frame-11.png",
        "/game/actions/ice/explosion/frame-12.png",
        "/game/actions/ice/explosion/frame-13.png",
        "/game/actions/ice/explosion/frame-14.png",
        "/game/actions/ice/explosion/frame-15.png",
        "/game/actions/ice/explosion/frame-16.png",
        "/game/actions/ice/explosion/frame-17.png",
        "/game/actions/ice/explosion/frame-18.png",
        "/game/actions/ice/explosion/frame-19.png",
        "/game/actions/ice/explosion/frame-20.png",
        "/game/actions/ice/explosion/frame-21.png",
        "/game/actions/ice/explosion/frame-22.png",
        "/game/actions/ice/explosion/frame-23.png",
        "/game/actions/ice/explosion/frame-24.png",
        "/game/actions/ice/explosion/frame-25.png",
        "/game/actions/ice/explosion/frame-26.png",
        "/game/actions/ice/explosion/frame-27.png",
        "/game/actions/ice/explosion/frame-28.png",
        "/game/actions/ice/explosion/frame-29.png",
        "/game/actions/ice/explosion/frame-30.png",
        "/game/actions/ice/explosion/frame-31.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png",
        "/game/actions/ice/explosion/frame-00.png"
      ],
      "projectileTimeline": {
        "width": 80,
        "height": 65,
        "anchor": {
          "x": 79,
          "y": 35
        },
        "frames": [
          {
            "source_frame": 1,
            "url": "/game/actions/ice/projectile/frame-00.png",
            "bitmap_ids": [
              136
            ],
            "transparent": false
          }
        ],
        "frameRate": 25,
        "loop": false,
        "source_character_id": 137,
        "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed",
        "loopEvidence": "Single original ice-projectile frame"
      },
      "explosionTimeline": {
        "width": 329,
        "height": 246,
        "anchor": {
          "x": 161,
          "y": 127
        },
        "frames": [
          {
            "source_frame": 1,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 2,
            "url": "/game/actions/ice/explosion/frame-01.png",
            "bitmap_ids": [
              139
            ],
            "transparent": false
          },
          {
            "source_frame": 3,
            "url": "/game/actions/ice/explosion/frame-02.png",
            "bitmap_ids": [
              141
            ],
            "transparent": false
          },
          {
            "source_frame": 4,
            "url": "/game/actions/ice/explosion/frame-03.png",
            "bitmap_ids": [
              143
            ],
            "transparent": false
          },
          {
            "source_frame": 5,
            "url": "/game/actions/ice/explosion/frame-04.png",
            "bitmap_ids": [
              145
            ],
            "transparent": false
          },
          {
            "source_frame": 6,
            "url": "/game/actions/ice/explosion/frame-05.png",
            "bitmap_ids": [
              147
            ],
            "transparent": false
          },
          {
            "source_frame": 7,
            "url": "/game/actions/ice/explosion/frame-06.png",
            "bitmap_ids": [
              149
            ],
            "transparent": false
          },
          {
            "source_frame": 8,
            "url": "/game/actions/ice/explosion/frame-07.png",
            "bitmap_ids": [
              151
            ],
            "transparent": false
          },
          {
            "source_frame": 9,
            "url": "/game/actions/ice/explosion/frame-08.png",
            "bitmap_ids": [
              153
            ],
            "transparent": false
          },
          {
            "source_frame": 10,
            "url": "/game/actions/ice/explosion/frame-09.png",
            "bitmap_ids": [
              155
            ],
            "transparent": false
          },
          {
            "source_frame": 11,
            "url": "/game/actions/ice/explosion/frame-10.png",
            "bitmap_ids": [
              157
            ],
            "transparent": false
          },
          {
            "source_frame": 12,
            "url": "/game/actions/ice/explosion/frame-11.png",
            "bitmap_ids": [
              159
            ],
            "transparent": false
          },
          {
            "source_frame": 13,
            "url": "/game/actions/ice/explosion/frame-12.png",
            "bitmap_ids": [
              161
            ],
            "transparent": false
          },
          {
            "source_frame": 14,
            "url": "/game/actions/ice/explosion/frame-13.png",
            "bitmap_ids": [
              163
            ],
            "transparent": false
          },
          {
            "source_frame": 15,
            "url": "/game/actions/ice/explosion/frame-14.png",
            "bitmap_ids": [
              165
            ],
            "transparent": false
          },
          {
            "source_frame": 16,
            "url": "/game/actions/ice/explosion/frame-15.png",
            "bitmap_ids": [
              167
            ],
            "transparent": false
          },
          {
            "source_frame": 17,
            "url": "/game/actions/ice/explosion/frame-16.png",
            "bitmap_ids": [
              169
            ],
            "transparent": false
          },
          {
            "source_frame": 18,
            "url": "/game/actions/ice/explosion/frame-17.png",
            "bitmap_ids": [
              171
            ],
            "transparent": false
          },
          {
            "source_frame": 19,
            "url": "/game/actions/ice/explosion/frame-18.png",
            "bitmap_ids": [
              173
            ],
            "transparent": false
          },
          {
            "source_frame": 20,
            "url": "/game/actions/ice/explosion/frame-19.png",
            "bitmap_ids": [
              175
            ],
            "transparent": false
          },
          {
            "source_frame": 21,
            "url": "/game/actions/ice/explosion/frame-20.png",
            "bitmap_ids": [
              177
            ],
            "transparent": false
          },
          {
            "source_frame": 22,
            "url": "/game/actions/ice/explosion/frame-21.png",
            "bitmap_ids": [
              179
            ],
            "transparent": false
          },
          {
            "source_frame": 23,
            "url": "/game/actions/ice/explosion/frame-22.png",
            "bitmap_ids": [
              181
            ],
            "transparent": false
          },
          {
            "source_frame": 24,
            "url": "/game/actions/ice/explosion/frame-23.png",
            "bitmap_ids": [
              183
            ],
            "transparent": false
          },
          {
            "source_frame": 25,
            "url": "/game/actions/ice/explosion/frame-24.png",
            "bitmap_ids": [
              185
            ],
            "transparent": false
          },
          {
            "source_frame": 26,
            "url": "/game/actions/ice/explosion/frame-25.png",
            "bitmap_ids": [
              187
            ],
            "transparent": false
          },
          {
            "source_frame": 27,
            "url": "/game/actions/ice/explosion/frame-26.png",
            "bitmap_ids": [
              189
            ],
            "transparent": false
          },
          {
            "source_frame": 28,
            "url": "/game/actions/ice/explosion/frame-27.png",
            "bitmap_ids": [
              191
            ],
            "transparent": false
          },
          {
            "source_frame": 29,
            "url": "/game/actions/ice/explosion/frame-28.png",
            "bitmap_ids": [
              193
            ],
            "transparent": false
          },
          {
            "source_frame": 30,
            "url": "/game/actions/ice/explosion/frame-29.png",
            "bitmap_ids": [
              195
            ],
            "transparent": false
          },
          {
            "source_frame": 31,
            "url": "/game/actions/ice/explosion/frame-30.png",
            "bitmap_ids": [
              197
            ],
            "transparent": false
          },
          {
            "source_frame": 32,
            "url": "/game/actions/ice/explosion/frame-31.png",
            "bitmap_ids": [
              199
            ],
            "transparent": false
          },
          {
            "source_frame": 33,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 34,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 35,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 36,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 37,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 38,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 39,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 40,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 41,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 42,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 43,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 44,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 45,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 46,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 47,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 48,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 49,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 50,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 51,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 52,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 53,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 54,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 55,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 56,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 57,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 58,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 59,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 60,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 61,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 62,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 63,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 64,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 65,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          },
          {
            "source_frame": 66,
            "url": "/game/actions/ice/explosion/frame-00.png",
            "bitmap_ids": [],
            "transparent": true
          }
        ],
        "frameRate": 25,
        "loop": false,
        "source_character_id": 201,
        "scope": "Bitmap-only static timeline reconstruction; vector fills and ActionScript behavior are not executed"
      },
      "rotationOffset": 0,
      "orientationEvidence": "Original ice-crystal local orientation retained",
      "candidatePhysics": {
        "power": 0.0,
        "radius": 60.0,
        "mass": 10.0,
        "weight": 70.0,
        "wind": 240.0,
        "drag": 1.0
      },
      "craterId": null,
      "flyingPartical": "",
      "visualEvidence": "Exact original SymbolClass tank.resource.bombs.Bomb1 in composite bombs/1.swf; local ball and boon display lists reconstructed statically. Later original candidate, 2009 exact animation chronology unconfirmed.",
      "parameterEvidence": "Matching later DDTank-II BallList candidate; ActionType=0 is shared by both actions and does not identify the action. FlyingPartical is only a trail reference."
    }
  }
}
